import "intl-tel-input/build/css/intlTelInput.css";
import intlTelInput from "intl-tel-input";
import maps from "../loadModules/maps";
import cartComponents from "../loadModules/cartComponents";
import LoginForm from "../loadModules/cart/LoginForm";
import CustomerForm from "../loadModules/cart/CustomerForm";
import PickupPointSelector from "../loadModules/cart/PickupPointSelector";
import useCartFormatting from "../composables/useCartFormatting";
import useCartStorage from "../composables/useCartStorage";
import useCartCustomer from "../composables/useCartCustomer";
import useCartAddress from "../composables/useCartAddress";
import AddressFields from "../basics/addressFields";
import { attachPhoneFormat, PHONE_UTILS } from "../basics/phoneField";
import CountryField from "../basics/countryField";

const POINT_ICON_FALLBACK = "data:image/svg+xml," + encodeURIComponent(
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 34 34"><rect width="34" height="34" rx="7" fill="#eef0f3"/>'
    + '<path d="M17 7a7 7 0 0 0-7 7c0 5.2 7 13 7 13s7-7.8 7-13a7 7 0 0 0-7-7zm0 9.5a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5z" fill="#6b7280"/></svg>'
);
const formatting = useCartFormatting();
const storage = useCartStorage();
const customer = useCartCustomer();
const address = useCartAddress();
const CHANNEL_CARRY = "channel-carry"; // sessionStorage: the details carried to another sale channel
// the order cannot be changed any more (closed unpaid at its deadline, being processed, paid) or its items are gone:
// the page reloads once in this time - /payment/{id} (the address the checkout already stands on) shows the order as
// it is now; a second refusal inside it is a message, never a reload loop
const ORDER_GONE_RELOAD = "order-gone-reload"; // sessionStorage
const ORDER_GONE_RELOAD_PAUSE_MS = 60 * 1000;
// after the Finish button a payment may be on its way (a PSP page, a bank's 3-D Secure): leaving the page then
// never gives the draft order back
const PAYMENT_LEAVE_GRACE_MS = 5 * 60 * 1000;

const Cart = {
    components: {
        maps,
        LoginForm,
        CustomerForm,
        PickupPointSelector,
        ...cartComponents,
    },
    data() {
        return {
            // the coupon field is always there (like in the big shops): the coupon is judged without an e-mail
            showCoupon: true,
            // the applied coupon depends on the customer (first order only) and no e-mail was given yet: it is checked again with one
            couponNeedsEmail: false,
            pageLoading: false,
            toasts: [],
            isLogged: false,
            comments: false,
            canLogin: false,
            startLogin: false,
            emailMistake: false,
            loginCode: "",
            basketError: null,
            terms: false,
            showPostCode: false,
            termsError: false,
            stockError: false,
            postCodeError: false,
            cityError: false,
            stateError: false,
            streetError: false,
            houseError: false,
            billCityError: false,
            billStreetError: false,
            billHouseError: false,
            billStateError: false,
            billCompanyError: false,
            billPostCodeError: false,
            billAreaError: false,
            emailError: false,
            invoiceError: false,
            phoneError: false,
            phoneErrorCode: 0,
            needChallenge: false,
            captchaID1: null,
            firstNameError: false,
            lastNameError: false,
            couponError: null,
            basketItemError: false,
            step: 1,
            checkoutSections: {user: true, delivery: true, shipping: true, billing: true, payment: true},
            shippingPrice: null,
            paymentPrice: null,
            items: [],
            warehouses: [0],
            payment: null,
            email: "",
            order: null,
            deliveryComment: "",
            shopComment: "",
            mapPostCode: "",
            pointPickerOpen: false,
            // pickup point picker on a phone: a map with a pull-up list (half / tall) and a courier filter
            pointCarrier: "",
            pointSheet: {state: "half", height: null, dragging: false},
            loginModalOpen: false,
            addMore: false,
            // transfer details of a bank transfer order (confirmation step)
            bankTransfer: null,
            copiedField: null,
            coupon: "",
            couponEditable: true,
            couponChecking: false, // the check request is on its way (the "remove" button is shown meanwhile, and after the coupon applied)
            basket: {
                id: "",
                token: "",
            },
            iti: null,
            freeShipping: false,
            walletSlotState: "off", // the wallet button in place of the order button: off | wait (loading) | on
            addressPicked: false, // she clicked a saved address herself
            addressFolded: false, // the finished shipping address shows as one line (with an edit button)
            deliveryChosenByUser: false, // the customer picked a delivery method herself (not the automatic selection)
            channelNote: "", // after a move from another sale channel: what was kept
            countryPicked: false, // she chose the shipping country here herself (not the default)
            extraCredit: 0,
            newAddress: false,
            uadressess: [], // saved addresses
            citySelector: {},
            userData: {
                firstName: "",
                lastName: "",
                email: "",
                phoneNumber: "",
                taxCode: "",
                euTaxCode: "",
            },
            countryShipping: {
                id: user_country_id,
                code: "",
                needPost: "",
                needArea: "",
                needState: "",
                postLocalName: "",
                stateType: 0,
                addressStyle: 1,
            }, // shipping country
            countryInvoice: {
                id: user_country_id,
                code: "",
                needPost: "",
                needArea: "",
                needState: "",
                postLocalName: "",
                stateType: 0,
                addressStyle: 1,
            }, // invoice country
            isInputLoding: false,
            blockedCustomer: false,
            limitedPayments: false,
            loadingFieldName: "",
            showLoginFields: false,
            pinToken: "",
            pinError: "",
            timeout: null,
            shipping: null, // shipping method
            deliveryType: null,
            showMethods: false,
            saturdayTick: 0,
            basketCreating: false,
            basketCreatingPromise: null,
            expressConfirming: false,
            deliveryStarted: false,
            backendPhone: "",
            paymentPreloaded: false,
            addressInputsFocused: false,
            savedShipping: {
                city: "",
                postcode: "",
                street: "",
                house: "",
                state: "",
                area: "",
                // what the courier of the method asks of the recipient (e.g. the Postnummer of a DHL Packstation)
                extra_data: "",
            },
            userBill: null,
            billAddress: {
                country: "",
                city: "",
                postcode: "",
                street: "",
                house: "",
                state: "",
                area: "",
                isCompany: false,
                taxNumber: "",
                euTaxNumber: "",
                businessName: "",
                firstName: "",
                lastName: "",
            },
            countryShippingError: false,
            userDataError: false,
            savedShippingError: false,
            invoice: null,

            zoom: 0,
            latitude: 0,
            longitude: 0,
            points: [],
            pointsLoading: false,
            rawRecommends: [],
            selectedPoint: undefined,
            errorPaymentMethod: null,
            paymentError: null,
            orderCouponApplied: false,
            initPaymentMethodId: null, // the method whose init-payment request is on its way
            draftSyncing: false,
            creatingOrder: false,
            creatingOrderSilent: false,
            finishRequestMode: false,
            finishClickedAt: 0, // when the Finish button last went through (PAYMENT_LEAVE_GRACE_MS)
            // one-page checkout sync (see scheduleCheckoutSync)
            syncTimer: null,
            copiedTimer: null,
            syncRunning: false,
            syncDirty: false,
            orderCreatePromise: null,
            initPaymentPromise: null,
            failedCreateSignature: null,
            failedDeliverySig: null,
            syncedDeliverySig: null,
            validatedCoupon: "",
            syncedCoupon: "",
            loadedPaymentSig: null,
            loadedAmount: null,
            syncedCustomerSig: null,
            failedCustomerSig: null,
            orderItemsSig: null,
            // the payment method the order was created with ({id, type})
            createdPayment: null,
            syncPromise: null,
            finishing: false,
            mobileSummaryOpen: false,
            // phone: the coupon field under the summary's head, opened by the chip in it (the summary itself stays closed)
            mobileCouponOpen: false,
            sectionAdvanceTimer: null,
            sectionDoneSnapshot: {},
            invoiceTouched: false,
            pointerInteraction: false,
            pointerInteractionTimer: null,
            ownBillAddress: null,
            touchedFields: {},
            loggedDataIncomplete: false,
            // the dial code of the phone selector (without +), kept from the selector
            phoneDial: "",
            // a logged in customer's complete contact section closes once, then the customer decides
            contactCollapsedOnce: false,
            methodUnavailableError: false,
            mapCenter: null,
            pointsLoadedArea: null,
            pointsReloadTimer: null,
            modalReturnFocus: null,
            scrollToSelectionAfterIdle: false,
            selectedSavedAddress: null,
            liveErrorTimer: null,
            emailCheckPending: false,
            pointsRequestUrl: null,
            paymentData: {},
            finishPaymentEvent: {},
            startPaymentEvent: {},
            initializePaymentButtonEvent: null,
            finishPaymentButtonEvent: null,
            paymentButtonSettings: null,
            isAllowPush: window?.allowPush,
            isEnabledPush: window?.enabledPush,
            discountValue: 0,
            // the discount an app gives the signed-in customer without a code (e.g. the loyalty program)
            automaticActive: false,
            memberPrices: {},
            memberFreeShipping: false,
            memberTimer: null,
            cartLabels: {
                currency: document.querySelector('meta[name="currency"]')?.content || "",
                emptyCart: "Cart is empty",
                buySomething: "Add a product to continue.",
                remove: "Remove",
                subtotal: "Subtotal",
                tooMuch: "The requested quantity is not available.",
                startPayment: "Continue",
                ...(window?.cartLabels ?? {}),
                trust: window?.cartLabels?.trust_message ?? "Secure checkout · 30-day returns",
            },
            cartConfig: window?.cartConfig ?? {},
        };
    },
    created() {
        window.addEventListener('allowPushChanged', this.updateAllowPush);
        document.addEventListener('focusin', this.onAddressFocusChange, true);
        document.addEventListener('focusout', this.onAddressFocusChange, true);
        // pointer: collapse after the click landed (never move the element
        // under the pointer between press and release); keyboard: on focus
        document.addEventListener('pointerdown', this.onCheckoutPointerDown, true);
        document.addEventListener('click', this.onCheckoutInteraction);
        document.addEventListener('focusin', this.onCheckoutFocus, true);
        // payment widgets (Stripe etc.) are iframes: the page only sees the
        // window losing focus to them
        window.addEventListener('blur', this.onWindowBlur);
        document.addEventListener('focusout', this.onFieldBlur, true);
        document.addEventListener('input', this.onFieldInput, true);
        document.addEventListener('change', this.onFieldInput, true);
        this.saturdayInterval = setInterval(() => {
            this.saturdayTick++;
        }, 60000);
    },
    updated() {
        // Vue re-renders :class on .form-group (e.g. a live error appears) and
        // drops the "filled"/"focus" classes forms.js set by hand - restore
        // them from the real input state so the floating label stays put
        this.syncFormGroupClasses();
    },
    beforeUnmount() {
        window.removeEventListener('allowPushChanged', this.updateAllowPush);
        document.removeEventListener('focusin', this.onAddressFocusChange, true);
        document.removeEventListener('focusout', this.onAddressFocusChange, true);
        document.removeEventListener('pointerdown', this.onCheckoutPointerDown, true);
        document.removeEventListener('click', this.onCheckoutInteraction);
        document.removeEventListener('focusin', this.onCheckoutFocus, true);
        window.removeEventListener('blur', this.onWindowBlur);
        document.removeEventListener('focusout', this.onFieldBlur, true);
        document.removeEventListener('input', this.onFieldInput, true);
        document.removeEventListener('change', this.onFieldInput, true);
        if (this.saturdayInterval) {
            clearInterval(this.saturdayInterval);
        }
    },
    computed: {
        // the countries the invoice country can be: an EU destination - any EU country; a non-EU destination -
        // only the destination itself (the server gives the superset: the EU countries and the non-EU shipping ones)
        invoiceCountryOptions() {
            const all = this.cartConfig?.invoiceCountries ?? [];
            const destination = (this.cartConfig?.countries ?? []).find((item) => String(item.id) === String(this.countryShipping.id))
                ?? all.find((item) => String(item.id) === String(this.countryShipping.id));
            if (!destination) return all;
            if (destination.is_eu == 1) return all.filter((item) => item.is_eu == 1);
            return all.filter((item) => String(item.id) === String(destination.id));
        },
        // the flags the AddressFields components show (shipping / invoice)
        shipErrors() {
            return {post: this.postCodeError, city: this.cityError, state: this.stateError, area: false, street: this.streetError, house: this.houseError};
        },
        billErrors() {
            return {post: this.billPostCodeError, city: this.billCityError, state: this.billStateError, area: this.billAreaError, street: this.billStreetError, house: this.billHouseError};
        },
        // everything the customer sync sends - one watcher instead of one per field
        customerSyncKey() {
            return this.customerSignature();
        },
        // the couriers of the points on offer (the filter chips show when there is more than one)
        pointCarriers() {
            return [...new Set(this.availablePoints.map((point) => point.carrier).filter(Boolean))];
        },
        // the courier filter: the map's markers and the list follow it
        filteredPoints() {
            return this.pointCarrier ? this.availablePoints.filter((point) => point.carrier === this.pointCarrier) : this.availablePoints;
        },
        visiblePoints() {
            return this.pointCarrier ? this.sortedPoints.filter((point) => point.carrier === this.pointCarrier) : this.sortedPoints;
        },
        // the point list follows the map: nearest to the map centre first
        sortedPoints() {
            const points = this.availablePoints;
            if (!this.mapCenter) {
                return points;
            }
            const center = this.mapCenter;
            // the nearest ones only (a list of 1000+ rows is heavy on phones);
            // the selected point always stays in it
            const sorted = points
                .map((point) => ({point, d: this.distanceKm(center.lat, center.lng, Number(point.geolat), Number(point.geolon))}))
                .sort((a, b) => a.d - b.d)
                .map((row) => row.point);
            const nearest = sorted.slice(0, 60);
            const selected = this.selectedPoint;
            if (selected && !nearest.some((point) => point.pointId === selected.pointId)) {
                const own = sorted.find((point) => point.pointId === selected.pointId);
                if (own) nearest.unshift(own);
            }
            return nearest;
        },
        // every error flag as the validator sees it right now
        liveErrorFlags() {
            const user = this.isLogged && !this.loggedDataIncomplete ? {} : this.sectionErrors("user");
            if (this.isLogged) delete user.terms;
            const delivery = this.sectionErrors("delivery");
            const billing = this.sectionErrors("billing");
            return {
                firstNameError: !!user.firstName, lastNameError: !!user.lastName, emailError: !!user.email, phoneError: !!user.phone, termsError: !!user.terms,
                postCodeError: !!delivery.postcode, cityError: !!delivery.city, stateError: !!delivery.state,
                streetError: !!delivery.street, houseError: !!delivery.house,
                savedShippingError: !!delivery.point || !!delivery.method,
                methodUnavailableError: !!delivery.methodUnavailable,
                invoiceError: !!billing.invoice, billCityError: !!billing.billCity, billStreetError: !!billing.billStreet,
                billHouseError: !!billing.billHouse, billStateError: !!billing.billState, billPostCodeError: !!billing.billPostCode,
                billAreaError: !!billing.billArea, billCompanyError: !!billing.billCompany,
            };
        },
        liveErrorKey() {
            return JSON.stringify(this.liveErrorFlags);
        },
        sectionsDoneKey() {
            return ["user", "delivery", "billing", "payment"].map((key) => this.isSectionDone(key) ? 1 : 0).join("");
        },
        lang(){
            return window?.lan;
        },
        localStorageList() {
            return storage.storageItems();
        },
        webshopId() {
            return this.cartConfig?.webshop?.id
                ?? document.head.querySelector('meta[name="webshop-id"]')?.content;
        },
        recommends() {
            return (this.rawRecommends ?? []).map((item) => {
                const listPrice = Number(item.product_prices?.[this.webshopId] ?? 0);
                const discountPrice = Number(item.product_discount_prices?.[this.webshopId] ?? 0);
                return {
                    id: item.id,
                    sku: item.sku,
                    serial: item.product?.serial ?? item.serial ?? null,
                    image: item.image,
                    name: item.product?.name?.[this.lang ?? "en"] ?? item.product?.name?.en ?? "",
                    price: discountPrice > 0 ? discountPrice : listPrice,
                    original_price: discountPrice > 0 ? listPrice : null,
                    added: (this.items ?? []).some((el) => el.id == item.id),
                };
            });
        },
        itemsNum() {
            let sum = 0;
            this.items.forEach((item) => {
                sum += item.quantity;
            });

            return sum;
        },
        hasPreorder() {
            if (this.items === null || this.items === undefined ||this.items.length < 1){
                return false;
            }
            for (const item of this.items) {
                if(item?.availability == 2){
                    return true;
                }
            }
            return false;
        },
        // what the customer pays (items + delivery + payment fee; a free
        // shipping coupon waives the delivery only)
        grandTotal() {
            return this.totalPrice + (this.freeShipping ? (this.paymentPrice ?? 0) : (this.shippingPrice ?? 0) + (this.paymentPrice ?? 0));
        },
        totalPrice() {
            let sum = this.itemsSum((item) => item.price);

            if(this.discountValue > 0){
                sum -= this.discountValue;
            }

            return sum;
        },
        // the items' total before the coupon: the prices /api/cart/check answers (sale price, no coupon)
        subtotalBeforeCoupon() {
            if (!this.validatedCoupon && !this.automaticActive) return this.totalPrice;
            return this.itemsSum((item) => item.price_before_coupon ?? item.price);
        },
        // what the customer gets without a code (the member's discount) as its own summary row
        memberRow() {
            if (this.validatedCoupon || (!this.automaticActive && !this.memberFreeShipping) || (this.items?.length ?? 0) < 1) return null;
            const off = Math.round((this.subtotalBeforeCoupon - this.totalPrice) * 100) / 100;
            return off > 0 ? {off} : (this.memberFreeShipping ? {off: 0} : null);
        },
        // the coupon's deduction as its own summary row (item level and cart level together);
        // a free shipping coupon has no deduction, just the row
        couponRow() {
            if (!this.validatedCoupon || (this.items?.length ?? 0) < 1) return null;
            const off = Math.round((this.subtotalBeforeCoupon - this.totalPrice) * 100) / 100;
            if (off > 0) return {off};
            return this.freeShipping ? {off: 0} : null;
        },
        // what the contact fields show (see CustomerForm): the CRM e-mail of a logged in customer,
        // and a phone number whose country code sits on the selector without that code
        emailShown() {
            return this.email ? this.email : ((this.isLogged && this.userData?.email) || "");
        },
        phoneShown() {
            const raw = String(this.userData?.phoneNumber ?? "");
            if (raw.charAt(0) !== "+") return raw;
            const dial = this.dialCodeOf(raw);
            // only when the selector already shows that country: a "+49 ..." typed over another country stays whole until the
            // library has moved the selector to it (it does that on keyup), or the code would vanish before it could
            return dial && dial === this.phoneDial ? raw.slice(1 + dial.length).trim() : raw;
        },
        // the phone with its country code (the closed section, the receipt)
        phoneFull() {
            const raw = String(this.userData?.phoneNumber ?? "").trim();
            if (!raw || raw.charAt(0) === "+") return raw;
            return this.phoneDial ? "+" + this.phoneDial + " " + raw : raw;
        },
        userDisplayName() {
            return [this.userData?.firstName, this.userData?.lastName].filter(Boolean).join(" ").trim();
        },
        // several couriers fit the address: with the theme option "keep_methods_open" the list stays
        // visible for the customer to choose from, instead of collapsing to the selected one
        walletAtOrderNow() {
            return this.walletAtOrder(this.payment);
        },
        // the shipping address is complete and valid: it can fold to a line
        canFoldAddress() {
            return this.deliveryAddressReady && this.shipping !== null && !this.isPickupDelivery
                && !this.postCodeError && !this.cityError && !this.stateError && !this.streetError && !this.houseError && !this.savedShippingError;
        },
        addressSummary() {
            const s = this.savedShipping ?? {};
            return [[s.postcode, s.city].filter(Boolean).join(" "), [s.street, s.house].filter(Boolean).join(" ")].filter(Boolean).join(", ");
        },
        methodListShouldStayOpen() {
            // only while the customer has to choose: an automatic-select courier (chosen for her) or her own choice folds the list
            return !!this.cartConfig?.checkout?.keep_methods_open && !!this.cartConfig?.groupDeliveryMethods
                && !this.deliveryChosenByUser
                && this.deliveryType !== null && Number(this.deliveryType) !== 2
                && this.deliveryAddressReady && Array.isArray(this.selectedGroupMethods) && this.selectedGroupMethods.length > 1
                && !this.selectedGroupMethods.some((method) => method.is_automatic_select);
        },
        // a logged in customer's contact data is complete (the section can start closed)
        loggedContactComplete() {
            return this.isLogged && !this.loggedDataIncomplete && this.isSectionDone("user");
        },
        freeShippingPercent() {
            const threshold = this.cartConfig?.freeDelivery?.price?.min_order_amount;
            if (!threshold) return 0;
            return Math.min(100, Math.round((this.totalPrice / Number(threshold)) * 100));
        },
        totalNetPrice() {
            let sum = 0;
            this.items.forEach((item) => {
                if(item.net_price) {
                    sum += item.quantity * item.net_price;
                }
            });

            return sum;
        },
        layerOpen() {
            return !!(this.pointPickerOpen || this.loginModalOpen);
        },
        // the VAT inside the total to pay: the items' VAT share (their list price against their net price,
        // so a coupon lowers the net too), applied to the delivery and the payment fee as well
        totalTax() {
            let gross = 0;
            let net = 0;
            this.items.forEach((item) => {
                if (!item.net_price) return;
                gross += item.quantity * (item.price_before_coupon ?? item.price);
                net += item.quantity * item.net_price;
            });
            if (gross <= 0) return this.totalPrice - this.totalNetPrice;
            return Math.round(this.grandTotal * (1 - net / gross) * 100) / 100;
        },
        totalExportTax() {
            let sum = 0;
            this.items.forEach((item) => {
                if(item.exportTax) {
                    sum += item.quantity * item.exportTax;
                }
            });

            return sum;
        },
        countryGroups() {
            return (this.cartConfig?.deliveryGroups ?? []).filter((group) => String(group.country_id) === String(this.countryShipping.id));
        },
        paymentSectionReady() {
            // payment methods are hidden until the other checkout parts are
            // valid (same gate as the delivery method list)
            return this.isSectionDone('user')
                && this.isSectionDone('delivery')
                && this.shipping !== null
                && this.isSectionDone('billing');
        },
        deliveryAddressReady() {
            const streetFilled = (this.savedShipping?.street ?? "").trim().length >= 1;
            if (Number(this.countryShipping.needPost) !== 1) {
                return streetFilled;
            }
            const postCode = (this.savedShipping?.postcode ?? "").trim();
            if (postCode.length < 2) {
                return streetFilled;
            }
            if (this.countryShipping.postRegex) {
                try {
                    if (new RegExp(this.countryShipping.postRegex).test(postCode)) {
                        return true;
                    }
                } catch (error) {
                    console.log("country post code regex error", error);
                    return streetFilled;
                }
                return streetFilled;
            }
            return streetFilled;
        },
        // the post code is complete and valid for the country: the
        // post-code-dependent prices (regions, e.g. Canary Islands) apply
        addressPostcodeKnown() {
            if (Number(this.countryShipping?.needPost) !== 1) {
                return false;
            }
            const postCode = (this.savedShipping?.postcode ?? "").trim();
            if (postCode.length < 2) {
                return false;
            }
            try {
                return !this.countryShipping.postRegex || new RegExp(this.countryShipping.postRegex).test(postCode);
            } catch (error) {
                return false;
            }
        },
        // the delivery type (home / pickup) is chosen before the post code:
        // always offered, never changed by the address
        selectableCountryGroups() {
            return this.countryGroups.filter((group) =>
                Number(group.type) === 2 || (group.methods ?? []).some((method) =>
                    String(method.country_id) === String(this.countryShipping.id) &&
                    this.allowDeliveryMethod(method.warehouses ?? [])
                )
            );
        },
        // package points whose own post code has a valid price of their method
        // (e.g. no GLS point on the Canary Islands)
        availablePoints() {
            return (this.points ?? []).filter((point) => this.pointAvailable(point));
        },
        countryDeliveryMethods() {
            return this.automaticFirst((this.cartConfig?.deliveryMethods ?? []).filter((method) =>
                String(method.country_id) === String(this.countryShipping.id) &&
                this.allowDeliveryMethod(method.warehouses ?? [])
            ));
        },
        countryUadressess() {
            return (this.uadressess ?? []).filter((ship) => String(ship.country) === String(this.countryShipping.id));
        },
        selectedGroup() {
            if (!this.cartConfig?.groupDeliveryMethods) {
                return null;
            }
            if (this.deliveryType === null || this.deliveryType === undefined || Number(this.deliveryType) === 2) {
                return null;
            }
            return (this.cartConfig?.deliveryGroups ?? []).find((g) =>
                String(g.country_id) === String(this.countryShipping.id) && Number(g.type) === Number(this.deliveryType)
            ) ?? null;
        },
        selectedGroupMethods() {
            if (!this.deliveryAddressReady) {
                return [];
            }
            const group = this.selectedGroup;
            if (!group) {
                return [];
            }
            return this.automaticFirst((group.methods ?? []).filter((method) =>
                String(method.country_id) === String(this.countryShipping.id) &&
                this.allowDeliveryMethod(method.warehouses ?? []) &&
                this.checkPostCodeRegex(method.post_code_regex) &&
                this.methodPricesForAddress(method).length > 0
            ));
        },
        // Thursday 12:00 - Friday 12:00 with a Saturday delivery on offer and the automatic-select courier chosen for the
        // customer: the Saturday option and that courier stay in view, the other couriers sit behind "More"
        saturdayPromo() {
            return !!this.cartConfig?.groupDeliveryMethods && !this.deliveryChosenByUser && !this.methodsExpanded
                && this.visibleSaturdayMethods.length > 0 && this.selectedGroupMethods.some((method) => method.is_automatic_select);
        },
        methodsExpanded() {
            return Boolean(this.showMethods && this.selectedGroupMethods.length > 1);
        },
        defaultGroupMethod() {
            const methods = this.selectedGroupMethods;
            return methods.find((method) => method.is_automatic_select) ?? methods[0] ?? null;
        },
        collapsedHomeMethod() {
            if (this.shipping && Number(this.shipping.type) !== 6 && Number(this.shipping.type) !== 2) {
                return this.shipping;
            }
            return this.defaultGroupMethod;
        },
        basketTrigger() {
            return Boolean(
                this.termsAccepted
                && this.deliveryStarted
                && (this.items?.length ?? 0) > 0
                && this.isSectionDone('user')
                && (this.countryShipping?.id ?? "") !== ""
                && (this.savedShipping?.city ?? "").length > 0
                && (this.savedShipping?.postcode ?? "").length > 0
                && !this.addressInputsFocused
            );
        },
        termsAccepted() {
            return this.isLogged || this.terms;
        },
        userSectionReady() {
            return this.isSectionDone('user');
        },
        visibleSaturdayMethods() {
            if (!this.cartConfig?.groupDeliveryMethods || this.selectedGroup === null) {
                return [];
            }
            if (this.shipping && Number(this.shipping.type) === 2) {
                return [];
            }
            const shippingAppId = this.shipping?.app_id;
            const saturdaySource = this.cartConfig?.webshop?.deliveryMethods ?? [];
            const saturdayList = Array.isArray(saturdaySource) ? saturdaySource : Object.values(saturdaySource ?? {});
            return saturdayList
                .filter((method) => method && Number(method.type) === 6)
                .filter((method) => this.hasSaturdayService() && shippingAppId === method.app_id)
                .filter((method) =>
                    String(method.country_id) === String(this.countryShipping.id) &&
                    this.checkPostCodeRegex(method.post_code_regex) &&
                    this.allowDeliveryMethod(method.warehouses ?? [])
                );
        },
        singleDeliveryMethod() {
            if (this.methodsExpanded || this.selectedGroup === null) {
                return null;
            }
            // the Saturday option stays in view until the customer chooses (or has chosen it)
            if (this.visibleSaturdayMethods.length > 0 && (!this.deliveryChosenByUser || Number(this.shipping?.type) === 6)) {
                return null;
            }
            return this.collapsedHomeMethod;
        },
        isPickupDelivery() {
            return this.shipping !== null && Number(this.shipping.type) === 2;
        },
        hasSelectedPickUpPoint() {
            return (this.savedShipping?.package_point?.length ?? 0) > 0;
        },
        // the extra input of the selected method: {label: {lang: text}, pattern, required, help: {lang: text}} or null
        extraField() {
            return this.shipping?.extra_field ?? null;
        },
        extraFieldLabel() {
            const label = this.extraField?.label ?? {};
            return label[this.lang] ?? label.en ?? Object.values(label)[0] ?? "";
        },
        extraFieldHelp() {
            const help = this.extraField?.help ?? {};
            return help[this.lang] ?? help.en ?? Object.values(help)[0] ?? "";
        },
        // missing (when it is required) or not following the pattern of the method
        extraFieldInvalid() {
            if (!this.extraField) {
                return false;
            }
            const value = (this.savedShipping?.extra_data ?? "").trim();
            if (value === "") {
                return !!this.extraField.required;
            }
            return !!this.extraField.pattern && !new RegExp(this.extraField.pattern, "u").test(value);
        },
        orderFinishedWithoutSelectedPickUpPoint() {
            return this.isPickupDelivery && !this.hasSelectedPickUpPoint;
        },
        isAddressDelivery() {
            return this.shipping !== null && (Number(this.shipping.type) === 1 || Number(this.shipping.type) === 5);
        },
        canUseShippingAsInvoice() {
            return (this.savedShipping?.city?.length ?? 0) > 0 && !this.hasSelectedPickUpPoint;
        },
        hasSavedInvoiceAddress() {
            return (this.userBill?.city?.length ?? 0) > 0;
        },
        // the invoice address form: the customer's own address (option 2), or nothing else to choose from
        needsInvoiceAddressForm() {
            return Number(this.invoice) === 2
                || (this.invoice === null && !this.canUseShippingAsInvoice && !this.hasSavedInvoiceAddress);
        },
    },
    async mounted() {
        this.validateShippingCountry();
        this.items = this.localStorageList || [];
        this.checklogin();
        this.checkProducts();
        this.loadPaymentButton();
        // the header cart links to checkout with ?checkout=1: checkout is the
        // 2nd step of this app, not a route. orderTab() waits for stock data itself.
        if (this.items.length && new URLSearchParams(window.location.search).has("checkout")) {
            this.orderTab();
        }
    },
    methods: {
        loadPaymentButton(){
            if(typeof payment_button === "undefined") {
                return;
            }
            let data = payment_button;
            this.paymentButtonSettings = data.payment_button_settings;
            this.paymentButtonSettings.shippings = data.shippings;
            this.paymentButtonSettings.countries = data.countries;
            this.paymentButtonSettings.id = data.id;
            if (
                data?.script?.url !== undefined &&
                data?.script?.url !== null &&
                data?.script?.script !== undefined &&
                data?.script?.script !== null &&
                data?.script?.url !== ""
            ) {
                this.loadScript(
                    data.script.url,
                    "/api/script/" + data.script.id + ".js",
                    this.startInitializePaymentButton
                );
            } else if (
                data?.script?.url !== undefined &&
                data?.script?.url !== null &&
                data?.script?.url !== ""
            ) {
                this.loadScript(data.script.url,null, this.startInitializePaymentButton);
            } else if (
                data?.script?.script !== undefined &&
                data?.script?.script !== null
            ) {
                console.log("/api/script/" + data.script.id + ".js");
                this.loadScript(
                    "/api/script/" + data.script.id + ".js",null, this.startInitializePaymentButton
                );
            }
        },
        checkCoupon() {
            if (this.coupon?.length < 2) {
                this.validatedCoupon = "";
                this.requestCouponSync();
                return;
            }
            this.couponEditable = false;

            let order = {
                items: [],
                country_id: this.countryShipping.id,
                email: this.userData.email || null,
                currency: currency,
                coupon: this.coupon,
                token: Cookies.getItem('login_token') || null,
            };

            for (const product of this.items) {
                if (product.id !== null && product.id !== undefined) {
                    order.items.unshift({
                        id: product.id,
                        quantity: product.quantity,
                    });
                }
            }
            this.couponError = null;
            this.freeShipping = false;

            // a failed check (an error page, an expired session, no network, no answer) is not a refused coupon: the
            // field opens again with an error text and the typed code stays for a one-tap retry. Without this the
            // field stayed locked (couponEditable = false) and the button spun for ever.
            const checkFailed = (sessionExpired) => {
                this.couponError = sessionExpired
                    ? (lang?.cart?.messages?.coupon_session_expired ?? "Your session has expired. Please refresh the page and try again.")
                    : (lang?.cart?.messages?.coupon_check_failed ?? "We could not check the coupon right now. Please try again.");
                this.couponEditable = true;
                this.validatedCoupon = "";
                this.couponNeedsEmail = false;
                this.requestCouponSync();
            };
            const abort = new AbortController();
            const timer = setTimeout(() => abort.abort(), 15000);
            this.couponChecking = true;

            fetch("/api/cart/check-discount", {
                method: "POST",
                headers: http.headers(),
                body: JSON.stringify(order),
                signal: abort.signal,
            })
                .then(async (response) => ({
                    status: response.status,
                    data: await response.json().catch(() => null),
                }))
                .then(({status, data}) => {
                    if(data?.success === false){
                        this.couponError = data.message;
                        this.coupon = "";
                        this.couponEditable = true;
                        this.validatedCoupon = "";
                        this.couponNeedsEmail = false;
                        this.requestCouponSync();
                        return;
                    }
                    if (!Array.isArray(data?.orderItems)) {
                        checkFailed(status === 419);
                        return;
                    }
                    this.couponNeedsEmail = !!data.needsCustomer && !this.userData.email;
                    this.freeShipping = data.freeShipping;
                    this.discountValue = data.discountValue;
                    this.extraCredit = data.extraDiscountAmount ?? 0;

                    for (const item of data.orderItems) {
                        let element = this.items
                            .find((e) => e.id == item.id);
                        if (!element) continue; // the answer names an item the cart no longer holds
                        element.original_price = item.originalPrice;
                        element.price = item.price;
                    }

                    // one-page checkout: the draft order gets the coupon through
                    // the checkout sync (or with its creation)
                    this.validatedCoupon = this.coupon;
                    this.requestCouponSync();
                })
                .catch(() => checkFailed(false))
                .finally(() => {
                    clearTimeout(timer);
                    this.couponChecking = false;
                });
        },
        allowDeliveryMethod(warehouseIds){
            if (warehouseIds.indexOf(0) > -1) {
                return true;
            }
            if(this.warehouses?.length > 0) {
                for (const warehouseId of this.warehouses) {
                    if (warehouseIds.indexOf(warehouseId) > -1) {
                        return true;
                    }
                }
            }

            return false;
        },
        checkProducts(retry=true){
            if (this.items === null || this.items === undefined ||this.items.length < 1){
                return;
            }
            let ids = this.items.map((e) => e.id);
            fetch("/api/cart/check", {
                method: "POST",
                headers: http.headers(),
                body: JSON.stringify({ ids: ids }),
            })
                .then((response) => response.json())
                .then((data) => {
                    this.rawRecommends = data.related;
                    this.warehouses = data.warehouses;
                    for (const item of this.items) {
                        if(data.items[item.id] === undefined){
                            if(retry) {
                                setTimeout(() => {
                                    this.checkProducts(false);
                                }, 400);
                            }
                            return;
                        }
                        item.price = data.items[item.id].price;
                        // the cart is shared by every channel: the repriced item gets this channel's currency
                        item.currency = currency;
                        item.availability = data.items[item.id].availability;
                        item.max = data.items[item.id].qt;
                        item.preorder = data.items[item.id].preorder;
                        item.original_price = data.items[item.id].original_price;
                        // the price before any coupon (the coupon row of the summary)
                        item.price_before_coupon = data.items[item.id].price;
                    }
                    this.updateLocalStorage();
                    this.applyMemberPrices();
                });
        },
        // the signed-in customer's discount without a code (the loyalty program's): the login check brings it with the cart
        // (setMemberPrices); the prices the cart check brings are the ones it is taken off, so it is applied when both are here
        setMemberPrices(discount) {
            const prices = {};
            if (Array.isArray(discount?.orderItems)) {
                for (const item of discount.orderItems) {
                    prices[item.id] = item.price;
                }
            }
            this.memberPrices = prices;
            this.memberFreeShipping = !!discount?.freeShipping;
            this.applyMemberPrices();
        },
        applyMemberPrices() {
            if (this.validatedCoupon) return; // a coupon was applied: its check (with the login) has the last word
            let off = 0;
            for (const item of this.items ?? []) {
                const price = this.memberPrices[item.id];
                if (price === undefined || item.price_before_coupon === undefined) continue; // the cart check is not here yet
                if (price < item.price_before_coupon) {
                    off += item.price_before_coupon - price;
                    item.price = price;
                }
            }
            this.automaticActive = off > 0;
            // the free shipping the program gives (a rule of the customer's status)
            this.freeShipping = this.memberFreeShipping;
        },
        // the cart changed (a quantity, an item removed): the conditions of the discount (a minimum) may have changed, ask again
        refreshMemberDiscount() {
            if (!Cookies.getItem('login_token') || this.validatedCoupon || Object.keys(this.memberPrices).length === 0) return;
            clearTimeout(this.memberTimer);
            this.memberTimer = setTimeout(() => this.checkAutomaticDiscount(), 400);
        },
        checkAutomaticDiscount() {
            const token = Cookies.getItem('login_token');
            if (!token || this.validatedCoupon || (this.items?.length ?? 0) < 1) {
                this.memberPrices = {};
                this.memberFreeShipping = false;
                this.automaticActive = false;
                return;
            }
            const order = {
                items: this.items.filter((product) => product.id !== null && product.id !== undefined)
                    .map((product) => ({id: product.id, quantity: product.quantity})),
                country_id: this.countryShipping.id,
                currency: currency,
                token: token,
            };
            fetch("/api/cart/check-discount", {
                method: "POST",
                headers: http.headers(),
                body: JSON.stringify(order),
            })
                .then((response) => response.json().catch(() => null))
                .then((data) => {
                    if (this.validatedCoupon || !Array.isArray(data?.orderItems)) return;
                    for (const item of this.items) {
                        // back to the price the cart check gave, then the discount on it
                        if (item.price_before_coupon !== undefined) item.price = item.price_before_coupon;
                    }
                    this.setMemberPrices(data);
                })
                .catch(() => { this.automaticActive = false; });
        },
        logout() {
            customer.logout(this);
        },
        deleteBasket() {
            // nothing to delete server-side when no basket was created yet
            if (!this.hasBasket()) {
                return;
            }
            if('serviceWorker' in navigator && navigator.serviceWorker && navigator.serviceWorker.controller && this.basket?.id > 0) {
                navigator.serviceWorker.controller.postMessage({
                    action: 'close_basket',
                    id: this.basket.id,
                    token: this.basket.token,
                    headers: http.headers()
                });
            }else{
                let del = this.basket.id;
                fetch('/api/cart/delete', {
                    method: 'POST',
                    headers: http.headers(),
                    body: JSON.stringify({
                        id:this.basket.id,
                        token:this.basket.token,
                    }),
                }).then((response) => response.json())
                    .then((data) => {
                        if (data.code === 200 && del === this.basket.id) {
                            this.basket.id = "";
                            this.basket.token = "";
                        }
                    });
            }
        },
        openCheckoutSections(names) {
            for (const name of names) {
                this.checkoutSections[name] = true;
            }
        },
        // a payment whose card field sits in the payment block (not a wallet button at the order button)
        hasCardField(payment) {
            return !!payment && this.isWidgetPayment(payment) && !this.walletAtOrder(payment);
        },
        // the payment block open and the card field in view (once the block has grown to its height)
        showPaymentCard(focus) {
            this.openCheckoutSections(['payment']);
            this.$nextTick(() => requestAnimationFrame(() => {
                const box = document.getElementById("payment-element-" + this.payment?.id);
                if (!box || box.offsetParent === null) return;
                const reveal = () => {
                    (box.closest(".form-group") || box).scrollIntoView({
                        block: "center",
                        behavior: window.matchMedia?.("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth",
                    });
                    if (focus) box.querySelector("iframe")?.focus({preventScroll: true});
                };
                // the opening block takes its height in an animation
                const body = box.closest(".checkout-block-body");
                const animations = typeof body?.getAnimations === "function" ? body.getAnimations() : [];
                if (animations.length) {
                    Promise.all(animations.map((a) => a.finished.catch(() => null))).then(reveal);
                } else {
                    reveal();
                }
            }));
        },
        checkOrder(){
            if (this.shipping !== null && Number(this.shipping.type) === 2 && this.invoice == 1) {
                this.invoice = 2; // a pickup point is not an invoice address
            }
            if (this.invoice == 2 || this.invoice === null) {
                this.defaultInvoiceCountry();
            }
            const user = this.isLogged && !this.loggedDataIncomplete ? {} : this.sectionErrors("user");
            if (this.isLogged) delete user.terms;
            if (this.isLogged && !this.isValidEmail(this.userData?.email)) user.email = true;
            const delivery = this.sectionErrors("delivery");
            const billing = this.sectionErrors("billing");

            this.termsError = !!user.terms;
            this.emailError = !!user.email;
            this.userDataError = (this.userData?.email ?? "") === "";
            this.firstNameError = !!user.firstName;
            this.lastNameError = !!user.lastName;
            this.phoneError = !!user.phone;
            this.phoneErrorCode = this.iti?.getValidationError?.() ?? 0;
            this.backendPhone = user.phone ? "" : this.phoneForBackend();

            this.countryShippingError = !!delivery.country;
            this.savedShippingError = !!delivery.point || !!delivery.method;
            this.methodUnavailableError = !!delivery.methodUnavailable;
            this.postCodeError = !!delivery.postcode;
            this.cityError = !!delivery.city;
            this.stateError = !!delivery.state;
            this.streetError = !!delivery.street;
            this.houseError = !!delivery.house;

            this.invoiceError = !!billing.invoice;
            this.billCityError = !!billing.billCity;
            this.billStreetError = !!billing.billStreet;
            this.billHouseError = !!billing.billHouse;
            this.billStateError = !!billing.billState;
            this.billCompanyError = !!billing.billCompany;
            this.billPostCodeError = !!billing.billPostCode;
            this.billAreaError = !!billing.billArea;

            const errorSections = [];
            if (Object.keys(user).length) errorSections.push("user");
            if (Object.keys(delivery).length) errorSections.push("delivery");
            if (Object.keys(billing).length) errorSections.push(this.sectionAvailable("billing") ? "billing" : "delivery");
            const thereIsError = errorSections.length > 0 || !!this.blockedCustomer;

            this.openCheckoutSections([...new Set(errorSections)]);
            if (errorSections.length > 0) {
                this.focusFirstInvalid();
            }
            return thereIsError;
        },
        async zeroOrderFinish() {
            let thereIsError = this.checkOrder();

            if(thereIsError || this.finishing){
                return;
            }
            this.finishing = true;
            let saved = false;
            try {
                saved = await this.ensureCheckoutSaved();
            } finally {
                this.finishing = false;
            }
            if (!saved) {
                return;
            }
            if (this.order?.id > 0 && this.payment === null) {
                // nothing to pay on an existing draft - it is finished by the
                // (free) payment init of the selected method only
                this.paymentError = lang?.cart?.messages?.missing_payment ?? "Please select a payment method.";
                this.openCheckoutSections(['payment']);
                return;
            }
            this.finishOrder(5);
        },
        paymentTab(paymentButton = false) {
            if (!paymentButton) {
                let thereIsError = this.checkOrder();
                if (thereIsError) {
                    return;
                }
            }
            if (paymentButton) {
                this.finishOrder();
            } else if (this.basket?.id > 0) {
                this.prepareDraftOrder();
            } else {
                this.createBasketRequest(false).then((created) => {
                    if (created) {
                        this.prepareDraftOrder();
                    }
                });
            }
        },
        /**
         * One-page checkout (scenario "create order early, silently"):
         * as soon as the user data + delivery method are valid, the order is
         * created in the background together with its payment (started with
         * the sale channel's default payment method). The returned payment
         * script/widget is rendered immediately, so pressing "Pay" on the
         * already visible payment section only charges - no extra step.
         */
        prepareDraftOrder() {
            if (this.order?.id > 0) {
                return this.initPayment();
            }
            if (this.payment == null) {
                const choice = this.defaultPaymentChoice();
                if (choice === null) {
                    // no safe default (offline-only webshop): fall back to
                    // creating the order on the final Pay click
                    this.proceedToPayment(false);
                    return;
                }
                // the payment watcher reacting to the change creates the
                // draft order + payment in the background
                this.payment = choice;
                return;
            }
            this.scheduleCheckoutSync(0); // background draft
        },
        /**
         * Redirect payment methods (display_type 3): they don't render a
         * widget - the draft order is not created for them, the order+payment
         * is created (and the user redirected) only on the Finish button;
         * the redirect url comes with the start-payment response.
         */
        // the display types the payment method has in this sale channel (the app's own setting can decide them)
        displayTypesOf(payment) {
            const raw = payment?.display_type;
            const list = Array.isArray(raw) ? raw : String(raw ?? "").split(",");
            return list.filter((v) => v !== "" && v !== null).map(Number);
        },
        // display type STANDALONE (2) without PAYMENT_OPTION (0): the method's button is not in its row but in place of the order button
        walletAtOrder(payment) {
            const types = this.displayTypesOf(payment);
            return types.includes(2) && !types.includes(0) && !types.includes(3) && this.isWidgetPayment(payment);
        },
        // where a payment app mounts its widget: its own row, or the order button's place
        paymentTarget(id) {
            if (this.walletAtOrder(this.payment)) {
                const slot = document.getElementById("payment-button-slot");
                if (slot) {
                    slot.innerHTML = "";
                    this.watchWalletSlot();
                    return slot;
                }
            }
            return document.getElementById(id);
        },
        // the slot shows a placeholder while the button loads and gives the order button back when no button comes (~12 s)
        watchWalletSlot() {
            clearInterval(this.walletTimer);
            const started = Date.now();
            this.walletSlotState = "wait";
            this.walletTimer = setInterval(() => {
                const slot = document.getElementById("payment-button-slot");
                if (!slot || !this.walletAtOrder(this.payment)) {
                    clearInterval(this.walletTimer);
                    this.walletSlotState = "off";
                    if (slot) slot.innerHTML = "";
                    return;
                }
                const hasWidget = !!slot.querySelector("iframe, button, [role=button], apple-pay-button, google-pay-button") || slot.textContent.trim() !== "";
                if (hasWidget) {
                    this.walletSlotState = "on";
                } else if (Date.now() - started > 12000) {
                    this.walletSlotState = "off";
                    clearInterval(this.walletTimer);
                } else {
                    this.walletSlotState = "wait";
                }
            }, 250);
        },
        isRedirectPayment(payment) {
            return payment?.redirect === true
                || (Array.isArray(payment?.display_type) && payment.display_type.map(Number).includes(3))
                || String(payment?.display_type ?? "").split(",").map(Number).includes(3);
        },
        /**
         * COD and redirect methods only act when the Finish button is pressed
         * (nothing loads/renders for them) - no loading states on selection.
         */
        isCODOrRedirect(payment) {
            return this.isOfflinePayment(payment) || this.isRedirectPayment(payment);
        },
        /**
         * Offline methods - COD (2), bank transfer (4): nothing is started
         * online, the order is placed on the Finish button only.
         */
        isOfflinePayment(payment) {
            return [2, 4].includes(Number(payment?.type));
        },
        isBankTransfer(payment) {
            return Number(payment?.type) === 4;
        },
        /** confirmation data of an offline order (bank transfer details) */
        offlineOrderPlaced(data) {
            this.bankTransfer = data?.bank_transfer ?? null;
            this.addMore = Number(this.payment?.type) === 2;
        },
        copyBankField(field, value) {
            const done = () => {
                this.copiedField = field;
                clearTimeout(this.copiedTimer);
                this.copiedTimer = setTimeout(() => { this.copiedField = null; }, 2000);
            };
            try {
                navigator.clipboard.writeText(String(value ?? "").trim()).then(done).catch(() => {});
            } catch (error) {
                console.error("[cart] copy failed", error);
            }
        },
        /**
         * Payment radio change handler: receives the full method object from
         * the template (no DOM value parsing - the object binding is lost in
         * the DOM).
         */
        onPaymentMethodChange(method) {
            try {
                this.payment = typeof method === "object" && method?.id !== undefined ? method : this.payment;
            } catch (error) {
                console.error("[cart] payment method change failed", error);
            }
        },
        defaultPaymentChoice() {
            const methods = (this.cartConfig?.paymentMethods ?? []).filter(
                (m) => (m.payment_identifier ?? "") !== "payment_button" && !this.isOfflinePayment(m)
                    && !this.isRedirectPayment(m)
                    && (m.delivery_method_id === null || m.delivery_method_id === undefined || m.delivery_method_id === "")
            );
            if (methods.length < 1) {
                // offline-only webshop: order is finished on creation, don't
                // pre-select it in the background
                return null;
            }
            const def = methods.find((m) => Number(m.is_default) === 1) ?? methods[0];
            return {id: def.id, type: def.type};
        },
        hasBasket() {
            return String(this.basket?.id ?? "").length > 0;
        },
        /**
         * One-page checkout sync. Every background action - basket, draft order,
         * delivery / coupon change, payment (re-)init - goes through this single
         * debounced, single-flight runner: whatever and however fast the user
         * changes things, each request is sent once, for the latest state only.
         * Changes made while a request is running mark the run dirty, it is
         * repeated once afterwards.
         */
        scheduleCheckoutSync(delay = 700) {
            clearTimeout(this.syncTimer);
            this.syncTimer = setTimeout(() => {
                this.syncTimer = null;
                this.runCheckoutSync();
            }, delay);
        },
        runCheckoutSync() {
            if (this.syncRunning) {
                this.syncDirty = true;
                return this.syncPromise;
            }
            this.syncPromise = this.runCheckoutSyncLoop();
            return this.syncPromise;
        },
        async runCheckoutSyncLoop() {
            this.syncRunning = true;
            try {
                do {
                    this.syncDirty = false;
                    await this.checkoutSyncStep();
                } while (this.syncDirty);
            } catch (error) {
                console.error("[cart] checkout sync failed", error);
            } finally {
                this.syncRunning = false;
                if (this.syncTimer === null) {
                    this.draftSyncing = false;
                }
            }
        },
        async checkoutSyncStep() {
            if (this.step === 5 || this.expressConfirming || this.finishRequestMode) {
                return;
            }
            // half-filled / invalid checkout (e.g. the address is being typed):
            // wait - the watchers schedule the sync again once it is valid
            if (!this.paymentSectionReady) {
                return;
            }
            if (this.order?.id > 0 && this.orderItemsSig !== null && this.itemsSignature() !== this.orderItemsSig) {
                // the cart items changed (back to the cart): the draft order
                // is replaced by a new one
                await this.abandonDraftOrder();
            }
            if (!(this.order?.id > 0)) {
                if (!this.canCreateDraftOrder()) {
                    return;
                }
                const data = await this.createOrderOnce(true);
                if (data === null) {
                    return;
                }
                this.handleCreatedOrder(data, 4);
                if (!(this.order?.id > 0)) {
                    return;
                }
            }
            if (this.deliverySignature() !== this.syncedDeliverySig) {
                if (!(await this.pushDeliveryChange())) {
                    return;
                }
            }
            if ((this.validatedCoupon ?? "") !== (this.syncedCoupon ?? "")) {
                if (!(await this.pushCouponChange())) {
                    return;
                }
            }
            if (this.customerSignature() !== this.syncedCustomerSig) {
                if (!(await this.pushCustomerChange())) {
                    return;
                }
            }
            if (this.needsPaymentInit()) {
                await this.initPayment();
            }
        },
        // start-payment responses come wrapped (JsonResponse: original.data)
        paymentInfo(payment) {
            return payment?.original?.data ?? payment?.data ?? payment;
        },
        isWidgetPayment(payment) {
            return payment?.id > 0 && !payment.express && !this.isCODOrRedirect(payment);
        },
        canCreateDraftOrder() {
            return this.paymentSectionReady
                && this.isWidgetPayment(this.payment)
                && this.draftCreateSignature() !== this.failedCreateSignature;
        },
        deliverySignature() {
            const s = this.savedShipping ?? {};
            return [
                this.shipping?.id ?? "", this.countryShipping?.id ?? "", s.postcode ?? "", s.city ?? "",
                s.street ?? "", s.house ?? "", s.state ?? "", s.area ?? "", s.package_point ?? "", s.extra_data ?? "",
            ].join("|");
        },
        /**
         * The invoice address the order uses (the checkbox/radio choice).
         */
        invoiceAddress() {
            if (Number(this.invoice) === 1) return this.savedShipping ?? {};
            if (Number(this.invoice) === 3) return this.userBill ?? {};
            return this.billAddress ?? {};
        },
        customerPayload() {
            const b = this.invoiceAddress();
            return {
                country_id: this.userData.countryID || this.countryShipping.id,
                email: this.userData.email || "",
                phone: this.phoneForBackend() || this.backendPhone || this.userData.phoneNumber || "",
                first_name: this.userData.firstName || "",
                last_name: this.userData.lastName || "",
                type: b.businessName ? 1 : 0,
                business_name: b.businessName || "",
                invoice_post_code: b.postcode || "",
                invoice_city: b.city || "",
                invoice_street: b.street || "",
                invoice_house: b.house || "",
                invoice_state: b.state || "",
                invoice_area: b.area || "",
                tax_code: this.userData.taxCode || (b.taxNumber ?? ""),
                eu_tax_code: this.userData.euTaxCode || (b.euTaxNumber ?? ""),
                shop_comment: this.shopComment || "",
                delivery_comment: this.deliveryComment || "",
            };
        },
        customerSignature() {
            return JSON.stringify(this.customerPayload());
        },
        itemsSignature() {
            return JSON.stringify((this.items ?? []).map((item) => [item.id, Number(item.quantity)]));
        },
        /**
         * Something is not saved on the ERP yet (or is being saved): the order
         * must not be finished with it.
         */
        isCheckoutDirty() {
            if (this.syncTimer !== null || this.syncRunning || this.creatingOrder || this.initPaymentPromise) {
                return true;
            }
            if (!(this.order?.id > 0)) {
                return false;
            }
            return this.deliverySignature() !== this.syncedDeliverySig
                || this.customerSignature() !== this.syncedCustomerSig
                || (this.validatedCoupon ?? "") !== (this.syncedCoupon ?? "")
                || this.needsPaymentInit();
        },
        /**
         * Finish: sends whatever is still pending right now (no debounce) and
         * waits until everything is saved. False when a change was rejected
         * (its error is shown) - the order must not be finished then.
         */
        async ensureCheckoutSaved() {
            for (let round = 0; round < 3 && this.isCheckoutDirty(); round++) {
                if (this.syncTimer !== null) {
                    clearTimeout(this.syncTimer);
                    this.syncTimer = null;
                }
                await this.runCheckoutSync();
                if (this.orderCreatePromise) await this.orderCreatePromise;
                if (this.initPaymentPromise) await this.initPaymentPromise;
            }
            return !this.isCheckoutDirty();
        },
        draftCreateSignature() {
            const b = this.billAddress ?? {};
            return JSON.stringify([
                this.userData?.email, this.userData?.phoneNumber, this.userData?.firstName, this.userData?.lastName,
                this.deliverySignature(), this.invoice, b.postcode, b.city, b.street, b.house, b.businessName,
                b.taxNumber, b.euTaxNumber, this.validatedCoupon, this.payment?.id,
            ]);
        },
        currentPaymentSig(methodId = this.payment?.id) {
            return [this.order?.id, methodId, this.syncedDeliverySig, this.syncedCoupon].join("#");
        },
        needsPaymentInit() {
            return this.order?.id > 0
                && this.isWidgetPayment(this.payment)
                && this.loadedPaymentSig !== this.currentPaymentSig();
        },
        /**
         * The delivery (method, package point, address) changed: instantly block
         * the loaded payment - its amount may be outdated - and sync.
         */
        markDeliveryChanged() {
            if (!(this.order?.id > 0)) {
                // not created yet: the creation takes the current delivery
                if (this.payment !== null) {
                    this.scheduleCheckoutSync();
                }
                return;
            }
            if (this.deliverySignature() === this.syncedDeliverySig) {
                return;
            }
            this.blockLoadedPayment();
            this.scheduleCheckoutSync();
        },
        onDraftInputChanged() {
            // not created yet (e.g. rejected data was corrected): retry; created:
            // save the customer / invoice / comment change - both debounced,
            // so never per keystroke
            if (this.payment === null && !(this.order?.id > 0)) {
                return;
            }
            if (this.order?.id > 0 && this.customerSignature() === this.syncedCustomerSig) {
                return;
            }
            this.scheduleCheckoutSync();
        },
        requestCouponSync() {
            if ((this.validatedCoupon ?? "") === (this.syncedCoupon ?? "")) {
                return;
            }
            if (this.order?.id > 0) {
                this.blockLoadedPayment(); // instant block on total change
                this.scheduleCheckoutSync(0);
            } else if (this.syncRunning) {
                this.scheduleCheckoutSync(0); // replayed after the running creation
            }
        },
        /**
         * Clears the currently rendered payment widget and shows the loading
         * (skeleton) state - called immediately when anything that affects the
         * running payment changes (delivery method/price, coupon).
         */
        blockLoadedPayment() {
            if (!this.isWidgetPayment(this.payment)) {
                // nothing rendered for COD/redirect/express
                return;
            }
            this.draftSyncing = true;
            this.blockPaymentOf(this.payment);
        },
        /**
         * Clears a specific (previously loaded) payment method's widget.
         */
        blockPaymentOf(payment) {
            if (payment?.id === undefined || payment?.id === null) {
                return;
            }
            const element = document.getElementById("payment-element-" + payment.id);
            if (element) {
                element.innerHTML = "";
            }
            // The wallet button's slot (and its watcher) is shared by the wallets. When the customer switched from
            // one wallet to another, the NEW one has already taken the slot (or is about to): the old one's cleanup
            // must not stop its watcher / set the state "off" - the order button would stay instead of the loader.
            // The slot is touched when this payment is the current one (a re-render) or the new one is no wallet.
            const sameAsCurrent = String(payment.id) === String(this.payment?.id);
            if (this.walletAtOrder(payment) && (sameAsCurrent || !this.walletAtOrder(this.payment))) {
                const slot = document.getElementById("payment-button-slot");
                if (slot) slot.innerHTML = "";
                clearInterval(this.walletTimer);
                this.walletSlotState = "off";
            }
            if (payment.id in this.startPaymentEvent) {
                this.startPaymentEvent[payment.id] = null;
            }
            delete this.paymentData[payment.id];
            if ((this.loadedPaymentSig ?? "").split("#")[1] === String(payment.id)) {
                this.loadedPaymentSig = null;
            }
        },
        pushDeliveryChange() {
            const signature = this.deliverySignature();
            if (signature === this.failedDeliverySig) {
                return Promise.resolve(false);
            }
            const body = {
                cart_token: this.order.cart_token,
                operation: null,
                method: this.shipping?.id ?? null,
                country_id: this.countryShipping.id,
                post_code: this.savedShipping.postcode ?? "",
                city: this.savedShipping.city ?? "",
                street: this.savedShipping.street ?? "",
                state: this.savedShipping.state ?? "",
                area: this.savedShipping.area ?? "",
                house: this.savedShipping.house ?? "",
                package_point: this.savedShipping.package_point ?? "",
                extra_data: this.extraField ? (this.savedShipping.extra_data ?? "").trim() : "",
                comment: this.deliveryComment ?? "",
            };
            return fetch("/api/orders/" + this.order.id + "/change-delivery", {
                method: "POST",
                headers: http.headers(),
                body: JSON.stringify(body),
            })
                .then((response) => response.json().then((data) => ({status: response.status, data})))
                .then(({status, data}) => {
                    if (this.reloadWhenOrderGone(status, data)) {
                        return false;
                    }
                    if (data?.success === false) {
                        this.failedDeliverySig = signature;
                        this.paymentError = data.message;
                        return false;
                    }
                    this.failedDeliverySig = null;
                    this.syncedDeliverySig = signature;
                    return true;
                })
                .catch(() => false);
        },
        applyCouponCode() {
            this.coupon = (this.coupon ?? "").trim();
            if (this.coupon.length < 2) return;
            this.checkCoupon();
        },
        // one order = one coupon: removing it lets the user enter another one
        toggleMobileCoupon() {
            this.mobileCouponOpen = !this.mobileCouponOpen;
            if (this.mobileCouponOpen) {
                this.$nextTick(() => document.getElementById("coupon-summary")?.focus());
            }
        },
        removeCouponCode() {
            this.couponError = null;
            this.couponNeedsEmail = false;
            this.validatedCoupon = "";
            this.resetCouponDisplay();
            this.requestCouponSync();
        },
        resetCouponDisplay() {
            this.coupon = "";
            this.couponEditable = true;
            this.freeShipping = this.memberFreeShipping;
            this.discountValue = 0;
            this.extraCredit = 0;
            this.checkProducts(false); // original item prices
        },
        pushCustomerChange() {
            const signature = this.customerSignature();
            if (signature === this.failedCustomerSig) {
                return Promise.resolve(false);
            }
            return fetch("/api/order/" + this.order.id + "/customer", {
                method: "POST",
                headers: http.headers(),
                body: JSON.stringify({...this.customerPayload(), cart_token: this.order.cart_token}),
            })
                .then((response) => response.json().then((data) => ({status: response.status, data})))
                .then(({status, data}) => {
                    if (this.reloadWhenOrderGone(status, data)) {
                        return false;
                    }
                    if (data?.success === false || data?.errors) {
                        this.failedCustomerSig = signature;
                        this.showOrderCreateError(data);
                        return false;
                    }
                    this.failedCustomerSig = null;
                    this.clearOrderCreateError();
                    this.syncedCustomerSig = signature;
                    if (data?.repriced === true || (data?.payment_price !== undefined && this.loadedAmount !== null
                        && Math.abs(Number(data.payment_price) - Number(this.loadedAmount)) > 0.001)) {
                        // amount / tax (VAT, payment fee) changed on the same order: fresh payment
                        this.blockLoadedPayment();
                    }
                    return true;
                })
                .catch(() => false);
        },
        // 403: the order is not this cart's to change any more; 409 items_unavailable: it was closed unpaid and its items
        // are gone. Reloads (once in ORDER_GONE_RELOAD_PAUSE_MS) and says so: true.
        reloadWhenOrderGone(status, data) {
            if (!(status === 403 || (status === 409 && data?.reason === "items_unavailable"))) {
                return false;
            }
            try {
                const at = Number(sessionStorage.getItem(ORDER_GONE_RELOAD) ?? 0);
                if (Date.now() - at < ORDER_GONE_RELOAD_PAUSE_MS) {
                    return false;
                }
                sessionStorage.setItem(ORDER_GONE_RELOAD, String(Date.now()));
            } catch (e) {
                // no storage: the reload may repeat, the order page it leads to does not change anything
            }
            this.pageLoading = true;
            window.location.reload();
            return true;
        },
        // the page is left with a draft order that is not being paid: its stock goes back (the /payment/{id} page takes
        // it up again when the items are still in stock). An order that is placed (step 5) or whose Finish just
        // went through is left alone. The service worker finishes the request after the page is gone.
        abandonOnLeave() {
            const order = this.order;
            if (!(order?.id > 0) || this.step === 5 || Date.now() - this.finishClickedAt < PAYMENT_LEAVE_GRACE_MS) {
                return;
            }
            if ('serviceWorker' in navigator && navigator.serviceWorker && navigator.serviceWorker.controller) {
                navigator.serviceWorker.controller.postMessage({
                    action: 'abandon_order',
                    id: order.id,
                    cart_token: order.cart_token,
                    headers: http.headers()
                });
                return;
            }
            fetch("/api/order/" + order.id + "/abandon", {
                method: "POST",
                headers: http.headers(),
                body: JSON.stringify({cart_token: order.cart_token}),
                keepalive: true,
            }).catch(() => null);
        },
        abandonDraftOrder() {
            const order = this.order;
            this.blockLoadedPayment();
            this.resetDraftOrder();
            return fetch("/api/order/" + order.id + "/abandon", {
                method: "POST",
                headers: http.headers(),
                body: JSON.stringify({cart_token: order.cart_token}),
            }).catch(() => null);
        },
        resetDraftOrder() {
            this.blockLoadedPayment();
            this.order = null;
            this.syncedDeliverySig = null;
            this.syncedCustomerSig = null;
            this.syncedCoupon = "";
            this.orderCouponApplied = false;
            this.loadedPaymentSig = null;
            this.loadedAmount = null;
            this.orderItemsSig = null;
            this.failedCreateSignature = null;
            this.failedDeliverySig = null;
            this.failedCustomerSig = null;
        },
        orderCouponRequest(payload) {
            return fetch("/api/order/" + this.order.id + "/coupon", {
                method: "POST",
                headers: http.headers(),
                body: JSON.stringify({...payload, cart_token: this.order.cart_token}),
            })
                .then((response) => response.json().then((data) => ({...data, httpStatus: response.status})))
                .catch(() => ({success: false, message: null}));
        },
        /**
         * Brings the draft order's coupon to the validated one: removes the
         * applied coupon first (if any), then adds the new one.
         */
        async pushCouponChange() {
            const target = this.validatedCoupon ?? "";
            if ((this.syncedCoupon ?? "") !== "") {
                const removed = await this.orderCouponRequest({action: "remove"});
                if (this.reloadWhenOrderGone(removed?.httpStatus, removed)) {
                    return false;
                }
                if (removed?.success === false) {
                    this.paymentError = removed.message;
                    return false;
                }
                this.syncedCoupon = "";
                this.orderCouponApplied = false;
            }
            if (target !== "") {
                const added = await this.orderCouponRequest({action: "add", coupon: target});
                if (this.reloadWhenOrderGone(added?.httpStatus, added)) {
                    return false;
                }
                if (added?.success === false) {
                    // rejected by the order: don't retry it, and roll the shown
                    // discount back - the page must never show less than the
                    // payment will charge
                    this.couponError = added.message;
                    this.validatedCoupon = "";
                    this.resetCouponDisplay();
                    return true;
                }
                this.syncedCoupon = target;
                this.orderCouponApplied = true;
            }
            return true;
        },
        proceedToPayment(paymentButton) {
            if (paymentButton) {
                this.finishOrder();
                return;
            }
            this.pageLoading = false;
            this.step = 4;
            setTimeout(() => {
                forms.load();
            }, 100);
            window.scrollTo({top: 0, behavior: "smooth"});
        },
        preloadPaymentScript() {
            if (this.paymentPreloaded) {
                return;
            }
            const preload = this.cartConfig?.paymentPreload;
            if (!preload?.script_url) {
                return;
            }
            this.paymentPreloaded = true;
            try {
                fetch(preload.script_url, {cache: "force-cache"}).catch(() => {});
                if (preload.script_id) {
                    fetch("/api/script/" + preload.script_id + ".js", {cache: "force-cache"}).catch(() => {});
                }
            } catch (error) {
                console.log("payment script preload skipped", error);
            }
        },
        // the shipping country: hers once she picked one here; until then the default (defaultShippingCountry)
        validateShippingCountry() {
            const countries = this.cartConfig?.countries ?? [];
            if (countries.length < 1) {
                return;
            }
            const delivers = (id) => id !== null && id !== undefined && id !== ""
                && countries.some((country) => String(country.id) === String(id));
            if (this.countryPicked && delivers(this.countryShipping.id)) {
                return;
            }
            const id = this.defaultShippingCountry(delivers, countries);
            if (String(id) === String(this.countryShipping.id)) {
                return;
            }
            this.countryShipping.id = id;
            this.loadShipping(id);
        },
        // the first this channel delivers to: the one she chose in the "Ship to" selector (`ship_country` cookie), a
        // saved address's (logged in), the visitor's by IP, the shop's own country, else the list's first
        defaultShippingCountry(delivers, countries) {
            const cookie = String(document.cookie ?? "").match(/(?:^|;\s*)ship_country=([^;]*)/);
            const hit = [
                cookie ? decodeURIComponent(cookie[1]) : null,
                ...(this.uadressess ?? []).map((saved) => saved.country),
                user_country_id,
                country,
            ].find(delivers) ?? countries[0].id;
            return isNaN(Number(hit)) ? hit : Number(hit);
        },
        // the delivery method is chosen for the customer only when it is the automatic-select one or the only one available
        pickAutomaticMethod(methods) {
            return (methods ?? []).find((method) => method.is_automatic_select) ?? ((methods ?? []).length === 1 ? methods[0] : null);
        },
        // the automatic-select method always on top
        automaticFirst(methods) {
            return [...methods].sort((a, b) => Number(!!b.is_automatic_select) - Number(!!a.is_automatic_select));
        },
        autoSelectDelivery() {
            if (this.shipping !== null) {
                return;
            }
            if (!this.cartConfig?.groupDeliveryMethods) {
                const method = this.pickAutomaticMethod(this.countryDeliveryMethods);
                if (method) {
                    this.shipping = method;
                    this.deliveryType = Number(this.shipping.type);
                }
                return;
            }
            const groups = this.selectableCountryGroups;
            if (this.deliveryType === null && groups.length !== 1) {
                return;
            }
            const group = this.deliveryType !== null
                ? (this.countryGroups.find((g) => String(g.country_id) === String(this.countryShipping.id) && Number(g.type) === Number(this.deliveryType)) ?? null)
                : groups[0];
            if (!group) {
                return;
            }
            if (Number(group.type) === 2) {
                this.deliveryType = 2;
                return;
            }
            this.deliveryType = group.type;
            if (!this.deliveryAddressReady) {
                this.shipping = null;
                this.showMethods = false;
                return;
            }
            const visible = (group.methods ?? []).filter((method) =>
                String(method.country_id) === String(this.countryShipping.id) &&
                this.allowDeliveryMethod(method.warehouses ?? []) &&
                this.checkPostCodeRegex(method.post_code_regex) &&
                this.methodPricesForAddress(method).length > 0
            );
            const autoSelectMethod = this.pickAutomaticMethod(visible);
            if (autoSelectMethod) {
                this.shipping = autoSelectMethod;
                this.showMethods = false;
            } else {
                this.shipping = null;
                this.showMethods = true;
            }
        },
        isMethodAvailableForAddress(method) {
            const candidate = this.countryDeliveryMethods.find((m) => String(m.id) === String(method?.id)) ?? method;
            if (String(candidate?.country_id ?? this.countryShipping.id) !== String(this.countryShipping.id)) {
                return false;
            }
            return this.checkPostCodeRegex(candidate?.post_code_regex)
                && (typeof this.methodPricesForAddress !== "function" || this.methodPricesForAddress(candidate).length > 0);
        },
        maybeCreateBasket() {
            // an order (being) created without a basket must not get one later
            if (this.hasBasket() || this.basketCreating || this.order?.id > 0 || this.orderCreatePromise) {
                return;
            }
            if (!this.termsAccepted || !this.deliveryStarted || (this.items?.length ?? 0) < 1 || !this.isSectionDone('user')) {
                return;
            }
            this.createBasketRequest(false);
        },
        /**
         * Logged-in users: create the basket already on entering the checkout
         * page (step 2), without waiting for the terms acceptance.
         */
        maybeCreateBasketEarly() {
            if (this.hasBasket() || this.basketCreating) {
                return;
            }
            if (!this.isLogged || (this.items?.length ?? 0) < 1 || (this.countryShipping?.id ?? "") === "") {
                return;
            }
            this.createBasketRequest(false);
        },
        createBasketRequest(blocking = false) {
            if (this.hasBasket()) {
                return Promise.resolve(true);
            }
            if (this.basketCreating) {
                return this.basketCreatingPromise ?? Promise.resolve(false);
            }
            let bodyContent = { products: [] };
            let counter = 0;
            bodyContent.load_id = window.AppEvents.getNextLoadId();
            bodyContent.url = location.href;
            bodyContent.email = this.userData.email;
            bodyContent.phone = this.userData.phoneNumber;
            bodyContent.first_name = this.userData.firstName;
            bodyContent.last_name = this.userData.lastName;
            bodyContent.country_id = this.countryShipping.id;
            bodyContent.city = this.savedShipping.city;
            bodyContent.post_code = this.savedShipping.postcode;
            bodyContent.state = this.savedShipping.state;
            bodyContent.delivery_method_id = this.shipping?.id || null;
            this.items.forEach((elem) => {
                bodyContent.products[counter] = {
                    id: elem.id,
                    quantity: elem.quantity,
                };
                counter++;
            });

            this.basketError = null;
            this.basketItemError = false;
            if (blocking) {
                this.pageLoading = true;
            }
            this.basketCreating = true;
            this.basketCreatingPromise = fetch("/api/cart/create", {
                method: "POST",
                headers: http.headers(),
                body: JSON.stringify(bodyContent),
            })
                .then((response) => response.json())
                .then((data) => {
                    if (data.code === 200) {
                        this.basket.id = data.data.id;
                        this.basket.token = data.data.token;
                        if(data.data?.limited_payments) {
                            this.limitedPayments = true;
                        }
                        if(data.data?.blocked_customer) {
                            this.blockedCustomer = true;
                        }

                        for (const item of this.items) {
                            let element = data.data.products.find((e) => item.id == e.id);
                            if(element === undefined){
                                continue;
                            }
                            if(this.coupon.length < 2) {
                                item.price = element.prices.grossPrice;
                                item.net_price = element.prices.netPrice;
                                item.exportTax = element.prices.exportTax;
                            }
                        }

                        let event = {};
                        event.product_ids = this.items.map(el => el.id);
                        event.currency = currency;
                        event.webstore_id = document.head.querySelector('meta[name="webshop-id"]').content;
                        event.value = this.items.reduce((sum, el) => sum + parseInt(el.quantity) * parseInt(el.price), 0);
                        event.num_items = this.items.map(el => el.quantity);
                        event.items = this.items.map(el => {
                            return {
                                item_id: el.id,
                                item_sku: el.sku,
                                item_name: el.name,
                                item_serial: el?.serial,
                                price: el.price,
                                quantity: el.quantity
                            };
                        });
                        AppEvents.callEvent("INITIATE_CHECKOUT", event);
                        this.preloadPaymentScript();
                        return true;
                    } else {
                        if(data.code === 404){
                            this.basketItemError = true;
                        }else {
                            this.basketError = data.message;
                        }
                        return false;
                    }
                })
                .catch((error) => {
                    this.basketError =
                        "There’s been a glitch… We’re not quite sure what went wrong. You can try again later, or contact us in our Help Center.";
                    console.log("error", error);
                    return false;
                })
                .finally(() => {
                    this.basketCreating = false;
                    this.basketCreatingPromise = null;
                    if (blocking) {
                        this.pageLoading = false;
                    }
                });
            return this.basketCreatingPromise;
        },
        checkPostCode(regex){
            if(this.savedShipping.postcode === undefined || this.savedShipping.postcode.length < 2){
                return false;
            }
            let exp = new RegExp(regex);
            const normalized = this.savedShipping.postcode.toUpperCase().replace(/\s+/g, "");
            return exp.test(this.savedShipping.postcode) || exp.test(normalized);
        },
        checkPostCodeRegex(regex){
            if(regex === undefined || regex === null || String(regex).length < 1){
                return true;
            }
            return this.checkPostCode(regex);
        },
        checkRegionPostCode(regex, postCode = this.savedShipping.postcode){
            if(regex === undefined || regex === null || String(regex).length < 1){
                return false;
            }
            if(postCode === undefined || postCode === null){
                return false;
            }
            const normalized = String(postCode).toUpperCase().replace(/\s+/g, "");
            if(normalized.length < 1){
                return false;
            }
            try {
                return new RegExp(regex).test(normalized);
            } catch (error) {
                console.log("region post code regex error", error);
                return false;
            }
        },
        methodPricesForAddress(method, postCode = this.savedShipping?.postcode) {
            const prices = method?.prices ?? [];
            if (prices.length === 0) {
                return prices;
            }
            const regionPrices = prices.filter((price) => String(price.post_code_regex ?? "").length > 0);
            if (regionPrices.length === 0) {
                return prices;
            }
            const matched = regionPrices.filter((price) => this.checkRegionPostCode(price.post_code_regex, postCode));
            if (matched.length > 0) {
                return matched;
            }
            return prices.filter((price) => String(price.post_code_regex ?? "").length === 0);
        },
        hasSaturdayService() {
            const now = new Date();
            const offset = Number(this.cartConfig?.warehouseTimezoneOffset);
            let warehouseNow = now;
            if (!Number.isNaN(offset)) {
                warehouseNow = new Date(now.getTime() + (offset + now.getTimezoneOffset()) * 60000);
            }
            this.saturdayTick;
            const currentDay = warehouseNow.getDay();
            const currentHour = warehouseNow.getHours();

            return (
                (currentDay === 4 && currentHour >= 12) ||
                (currentDay === 5 && currentHour < 12)
            );
        },
        clearSelectedShipping() {
            this.savedShipping = {
                country: "",
                city: "",
                postcode: "",
                street: "",
                house: "",
                state: "",
                area: "",
            };
        },
        formatPrice(price, curr = currency){
            return formatting.formatPrice(price, curr);
        },
        shippingPrices(prices, number = false, pointType = null, calcWithFreeShipping = true){
            return formatting.shippingPrices(this, prices, number, pointType, calcWithFreeShipping);
        },
        clearBillingAddress(){
            this.billAddress = {
                country: "",
                city: "",
                postcode: "",
                street: "",
                house: "",
                state: "",
                area: "",
                isCompany: false,
                taxNumber: "",
                euTaxNumber: "",
                businessName: "",
                firstName: "",
                lastName: "",
            };
            Array.from(document.querySelectorAll(".bill-address")).forEach(
                (el) => el.classList.remove("filled")
            );
        },
        cartTab() {
            this.step = 1;
            this.deleteBasket();
            this.iti = null;
            this.deliveryStarted = false;
            this.basketCreating = false;
            this.basketCreatingPromise = null;
            document.getElementsByTagName("header")[0].style.display = "block";
            document.getElementsByTagName("footer")[0].style.display = "block";
        },
        toggleCheckoutSection(name) {
            if (this.checkoutSections[name]) {
                this.checkoutSections[name] = false;
                return;
            }
            this.openSection(name);
        },
        isValidEmail(email) {
            return /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(email ?? "");
        },
        setEmail(value) {
            this.email = value;
            if (this.userData.email !== value) {
                this.userData.email = value;
            }
            this.advanceSections('user');
        },
        updateUserData(patch) {
            Object.assign(this.userData, patch);
            this.advanceSections('user');
        },
        setPhone(value) {
            this.userData.phoneNumber = value;
            this.advanceSections('user');
        },
        // opening never closes other sections - that only happens when the user
        // works in a later section (onCheckoutInteraction)
        openSection(name) {
            this.checkoutSections[name] = true;
        },
        activateSection(name) {
            if (name === "delivery") {
                this.deliveryStarted = true;
            }
            this.checkoutSections[name] = true;
        },
        selectDeliveryMethod() {
            this.showMethods = false;
            this.activateSection('delivery');
        },
        // The customer's OWN choice of a courier (or, in confirmPickupPoint, of a pickup point) folds the list of
        // couriers to the chosen one (with its "change" button). The rest of the delivery section (invoice address,
        // order note) stays open - it is not part of the choice. Only a click gets here: the automatic selection
        // never folds anything. Theme option: config.json "checkout": {"collapse_methods_on_choice": true}.
        userChoseDelivery() {
            this.deliveryChosenByUser = true;
            if (!this.cartConfig?.checkout?.collapse_methods_on_choice) return;
            setTimeout(() => {
                this.showMethods = false;
                if (this.canFoldAddress) this.addressFolded = true;
            }, 200);
        },
        // The terms ticked with a finished contact section: the contact folds and the delivery opens at once
        // (not after the section-advance delay), and the page follows to the delivery head.
        termsChosen(event) {
            if (!event.target.checked || !this.isSectionDone("user")) return;
            this.checkoutSections.user = false;
            this.activateSection("delivery");
            this.$nextTick(() => this.scrollToNextSection("user"));
        },
        foldPickedAddress() {
            if (this.addressPicked && this.canFoldAddress && this.cartConfig?.checkout?.collapse_methods_on_choice) this.addressFolded = true;
        },
        editAddress() {
            this.addressFolded = false;
            this.addressPicked = false;
            this.$nextTick(() => {
                const field = document.querySelector("#newAddress input, #newAddress select") || document.getElementById("savedShipping-0");
                if (field) field.focus();
            });
        },
        confirmPickupPoint() {
            this.closePointPicker();
            if (this.selectedPoint) setTimeout(() => this.userChoseDelivery(), 300);
        },
        scrollToNextSection(name) {
            const current = document.querySelector('[data-checkout-section="' + name + '"]');
            if (!current) return;
            const next = [...document.querySelectorAll('#cart [data-checkout-section]')].find((x) => {
                if (!(current.compareDocumentPosition(x) & Node.DOCUMENT_POSITION_FOLLOWING)) return false;
                const body = x.querySelector('.checkout-block-body');
                return body && getComputedStyle(body).display !== 'none';
            });
            const y = (next || current).getBoundingClientRect().top + window.scrollY - 16;
            const reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            window.scrollTo({ top: y, behavior: reduced ? 'auto' : 'smooth' });
        },
        toggleDeliverySection() {
            this.openSection("delivery");
        },
        /**
         * Sections open by themselves only when the previous one BECAME
         * complete (valid) - checked after the user stopped typing, so a
         * section never opens mid-typing. Nothing is closed here.
         */
        advanceSections() {
            clearTimeout(this.sectionAdvanceTimer);
            this.sectionAdvanceTimer = setTimeout(() => this.openNextCompletedSections(), 800);
        },
        openNextCompletedSections() {
            const order = ["user", "delivery", "billing", "payment"];
            const now = {};
            for (const key of order) {
                now[key] = this.isSectionDone(key);
            }
            order.forEach((key, index) => {
                if (now[key] && !this.sectionDoneSnapshot[key]) {
                    const next = order.slice(index + 1).find((later) => !now[later] && this.sectionAvailable(later));
                    if (next) {
                        this.checkoutSections[next] = true;
                    }
                }
            });
            this.sectionDoneSnapshot = now;
        },
        // the billing section is only rendered when an own invoice form is needed
        sectionAvailable(name) {
            if (name === "billing") {
                return this.shipping !== null && this.needsInvoiceAddressForm;
            }
            return true;
        },
        /**
         * The user works in a section: the complete sections above it collapse,
         * keeping the section the user looks at in place (no page jump).
         */
        fieldErrorFlag(id) {
            const map = {
                firstname: "firstNameError", lastname: "lastNameError", email: "emailError", "phone-cart": "phoneError", terms: "termsError",
                "ship-postal-code": "postCodeError", "ship-city": "cityError", "ship-state": "stateError",
                "ship-street": "streetError", "ship-house": "houseError", "ship-address": "streetError", "bill-address": "billStreetError",
                "bill-postal-code": "billPostCodeError", "bill-city": "billCityError", "bill-state": "billStateError",
                "bill-area": "billAreaError", "bill-street": "billStreetError", "bill-house": "billHouseError",
                "business-name": "billCompanyError",
            };
            return map[id] ?? null;
        },
        onFieldInput(event) {
            const flag = this.fieldErrorFlag(event.target?.id);
            if (flag && (event.type === "change" || String(event.target.value ?? "").length > 0)) {
                this.touchedFields[flag] = true;
                // typing restarts the "stopped typing" timer even if the error
                // state itself did not change (e.g. empty -> still invalid)
                clearTimeout(this.liveErrorTimer);
                this.liveErrorTimer = setTimeout(() => this.applyLiveErrors(true), 700);
            }
        },
        onFieldBlur(event) {
            const flag = this.fieldErrorFlag(event.target?.id);
            if (flag) {
                this.touchedFields[flag] = true;
                // after the focus moved on (activeElement is the next field then)
                setTimeout(() => this.applyLiveErrors(true), 0);
            }
        },
        /**
         * Shows / hides the field errors from the validator: a fixed field is
         * cleared at once, an invalid one is shown once the user touched it.
         */
        applyLiveErrors(showNew) {
            const live = this.liveErrorFlags;
            // a new error is never shown on the field the user is typing in -
            // only once the focus left it (Finish still shows everything)
            const focusedFlag = this.fieldErrorFlag(document.activeElement?.id);
            for (const flag in live) {
                if (!live[flag] && this[flag]) {
                    this[flag] = false;
                } else if (showNew && live[flag] && !this[flag] && this.touchedFields[flag] && flag !== focusedFlag) {
                    this[flag] = true;
                }
            }
            if (this.phoneError) {
                this.phoneErrorCode = this.iti?.getValidationError?.() ?? 0;
            }
        },
        syncFormGroupClasses() {
            const root = this.$el?.parentNode ?? document;
            root.querySelectorAll?.(".form-group").forEach((group) => {
                const field = group.querySelector("input:not([type=radio]):not([type=checkbox]), select, textarea");
                if (!field) return;
                group.classList.toggle("filled", String(field.value ?? "").length > 0);
                group.classList.toggle("focus", document.activeElement === field);
            });
        },
        onCheckoutPointerDown() {
            this.pointerInteraction = true;
            clearTimeout(this.pointerInteractionTimer);
            this.pointerInteractionTimer = setTimeout(() => { this.pointerInteraction = false; }, 800);
        },
        // the focus went into an iframe of a checkout section (e.g. the card
        // number field of the payment widget): the complete sections above close
        onWindowBlur() {
            // the window loses focus on the press already: collapsing then
            // would move the widget mid-click and swallow the first keystrokes -
            // wait for the click to finish, and only if the focus stayed there
            setTimeout(() => {
                const frame = document.activeElement;
                if (frame?.tagName !== "IFRAME") return;
                const block = frame.closest("[data-checkout-section]");
                if (block && (this.step === 2 || this.step === 3 || this.step === 4)) {
                    this.collapseDoneSectionsAbove(block.dataset.checkoutSection, block);
                }
            }, 350);
        },
        onCheckoutFocus(event) {
            if (!this.pointerInteraction) {
                this.onCheckoutInteraction(event);
            }
        },
        onCheckoutInteraction(event) {
            if (this.step !== 2 && this.step !== 3 && this.step !== 4) {
                return;
            }
            const block = event.target?.closest?.("[data-checkout-section]");
            if (!block) {
                return;
            }
            this.collapseDoneSectionsAbove(block.dataset.checkoutSection, block);
        },
        collapseDoneSectionsAbove(name, anchor = null) {
            const order = ["user", "delivery", "billing", "payment"];
            // every complete section above collapses (after the click landed, so
            // nothing moves under the pointer); the page compensates as far as
            // it can - near the top the section may move up a little
            const toClose = order.slice(0, order.indexOf(name))
                .filter((key) => this.checkoutSections[key] && this.isSectionDone(key));
            anchor = anchor ?? document.querySelector('[data-checkout-section="' + name + '"]');
            if (toClose.length < 1) {
                return;
            }
            const before = anchor?.getBoundingClientRect().top ?? null;
            toClose.forEach((key) => { this.checkoutSections[key] = false; });
            this.$nextTick(() => {
                if (before === null || !anchor) return;
                const delta = anchor.getBoundingClientRect().top - before;
                if (Math.abs(delta) > 1) {
                    window.scrollBy({top: delta, left: 0, behavior: "instant"});
                }
            });
        },
        /**
         * Finish with errors: the first invalid field is scrolled into view
         * and focused (its error is announced by its section).
         */
        focusFirstInvalid() {
            this.afterRender(() => {
                const candidates = document.querySelectorAll(
                    '[data-checkout-section] [aria-invalid="true"], [data-checkout-section] .error input, [data-checkout-section] .error select, [data-checkout-section] .error textarea, [data-checkout-section] .alert-danger'
                );
                const target = Array.from(candidates).find((el) => el.offsetParent !== null);
                if (!target) {
                    return;
                }
                const reduce = window.matchMedia?.("(prefers-reduced-motion: reduce)")?.matches;
                target.scrollIntoView({block: "center", behavior: reduce ? "auto" : "smooth"});
                if (typeof target.focus === "function" && target.matches("input, select, textarea, button")) {
                    target.focus({preventScroll: true});
                }
            });
        },
        compactCheckoutSections() {
            this.sectionDoneSnapshot = {
                user: this.isSectionDone("user"), delivery: this.isSectionDone("delivery"),
                billing: this.isSectionDone("billing"), payment: this.isSectionDone("payment"),
            };
            let openNext = true;
            for (const key of ["user", "delivery", "billing", "payment"]) {
                if (!this.isSectionDone(key) && openNext) {
                    this.checkoutSections[key] = true;
                    openNext = false;
                } else {
                    this.checkoutSections[key] = false;
                }
            }
        },
        selectSavedAddress(ship) {
            // a copy: editing the form must not change the saved entry
            this.savedShipping = {...ship, package_point: "", extra_data: this.savedShipping?.extra_data ?? ""};
            this.selectedSavedAddress = ship;
            this.newAddress = false;
            this.activateSection('delivery');
            this.advanceSections('delivery');
            // her own click on a saved address: as soon as the courier is settled too, the address folds to its line
            this.addressPicked = true;
            setTimeout(() => this.foldPickedAddress(), 700);
        },
        // Σ quantity × price of the items; a company with an EU tax number outside our country pays net
        itemsSum(priceOf) {
            let sum = 0;
            this.items.forEach((item) => {
                if(
                    this.billAddress?.isCompany && this.billAddress.euTaxNumber?.length > 3 &&
                    this.countryShipping.id !== country && item.net_price
                ){
                    sum += item.quantity * item.net_price;
                }else {
                    sum += item.quantity * priceOf(item);
                }
            });
            return sum;
        },
        // "Colour: Black · Size: XS": the variant values the product page put on the item, labelled by the
        // characteristic types' names; older items only have the two values, shown without labels
        itemAttributes(item) {
            if (Array.isArray(item.attributes) && item.attributes.length) {
                return item.attributes.filter((a) => a && String(a.value ?? "").trim())
                    .map((a) => (a.label ? a.label + ": " : "") + String(a.value).trim()).join(" · ");
            }
            return [item.color, item.size].map((v) => String(v ?? "").trim()).filter(Boolean).join(" · ");
        },
        // the country code of an international number, by the longest matching dial code of the phone library
        dialCodeOf(raw) {
            const digits = String(raw).replace(/\D/g, "");
            const list = (intlTelInput.getCountryData ? intlTelInput.getCountryData() : (window.intlTelInputGlobals?.getCountryData?.() ?? []));
            let best = "";
            for (const c of list) {
                if (c.dialCode.length > best.length && digits.startsWith(c.dialCode)) best = c.dialCode;
            }
            return best;
        },
        phoneForBackend() {
            let backendPhone = (this.userData?.phoneNumber ?? "").replace(/[\s()\-.]/g, "");
            if (this.iti != null && !this.expressConfirming) {
                if (this.isLogged) {
                    if (backendPhone[0] !== "+") {
                        backendPhone = this.iti.getNumber();
                    }
                } else {
                    backendPhone = this.iti.getNumber();
                }
            }
            return backendPhone ?? "";
        },
        isHomeDelivery() {
            // grouped flow: the type is chosen first, the method follows the address
            const type = this.shipping ? Number(this.shipping.type) : Number(this.deliveryType);
            return type === 1 || type === 5;
        },
        /**
         * The single source of truth of the checkout validation: the section
         * ticks, the automatic section opening, the draft order creation and
         * Finish all use it. Returns {field: true} for every invalid field.
         */
        sectionErrors(name) {
            const errors = {};
            const regexFails = (regex, value) => regex !== null && regex !== undefined && String(regex).length > 0
                && (value ?? "").length > 0 && !new RegExp(regex).test(value);
            switch (name) {
                case "user": {
                    if (!this.termsAccepted) errors.terms = true;
                    if (!this.isValidEmail(this.userData?.email)) errors.email = true;
                    // separate fields, separate errors: typing one name never flags the other
                    if ((this.userData?.firstName?.length ?? 0) < 2) errors.firstName = true;
                    if ((this.userData?.lastName?.length ?? 0) < 2) errors.lastName = true;
                    const phone = this.phoneForBackend();
                    if (phone.length < 5 || phone[0] !== "+" || !/^\+?\d{4,26}/.test(phone)) {
                        errors.phone = true;
                    } else if (this.iti != null && !this.isLogged && !this.expressConfirming && !this.iti.isValidNumber()) {
                        const code = this.iti.getValidationError();
                        if (code !== 4 && code !== 0) errors.phone = true;
                    }
                    break;
                }
                case "delivery": {
                    const s = this.savedShipping ?? {};
                    if ((this.countryShipping?.code ?? "") === "") errors.country = true;
                    if (this.shipping === null || this.shipping === undefined) {
                        errors.method = true;
                        if (!this.isHomeDelivery()) break; // still validate the typed address
                    } else if (Number(this.shipping.type) === 2) {
                        if ((s.package_point ?? "") === "" && !this.selectedPoint) errors.point = true;
                        if (this.extraFieldInvalid) errors.extraData = true;
                        break;
                    }
                    if (this.shipping && this.addressPostcodeKnown && !this.isMethodAvailableForAddress(this.shipping)) {
                        errors.methodUnavailable = true; // no valid price for this post code
                    }
                    if (!this.isHomeDelivery()) break;
                    const c = this.countryShipping ?? {};
                    if (Number(c.needPost) === 1 && (s.postcode ?? "").length < 1) errors.postcode = true;
                    if (regexFails(c.postRegex, s.postcode)) errors.postcode = true;
                    if ((s.city ?? "").length < 1) errors.city = true;
                    if (Number(c.needState) === 1 && (s.state ?? "").length < 1) errors.state = true;
                    if ((s.street ?? "").length < 1) errors.street = true;
                    if ((s.house ?? "").length < 1 || regexFails(c.houseRegex, s.house)) errors.house = true;
                    break;
                }
                case "billing": {
                    if (this.isPickupDelivery && Number(this.invoice) === 1) {
                        errors.invoice = true; // a pickup point is not an invoice address
                        break;
                    }
                    const b = this.invoiceAddress();
                    if ((b?.city?.length ?? 0) < 2 || (b?.street?.length ?? 0) < 2) errors.invoice = true;
                    if (Number(this.invoice) !== 1 && Number(this.invoice) !== 3) {
                        const c = this.countryInvoice ?? {};
                        if ((b?.city?.length ?? 0) < 1) errors.billCity = true;
                        if ((b?.street?.length ?? 0) < 1) errors.billStreet = true;
                        if ((b?.house?.length ?? 0) < 1 || regexFails(c.houseRegex, b?.house)) errors.billHouse = true;
                        if (Number(c.needState) === 1 && (b?.state?.length ?? 0) < 1) errors.billState = true;
                        if (Number(c.needPost) === 1 && (b?.postcode?.length ?? 0) < 1) errors.billPostCode = true;
                        if (regexFails(c.postRegex, b?.postcode)) errors.billPostCode = true;
                        if (Number(c.needArea) === 1 && (b?.area?.length ?? 0) < 1) errors.billArea = true;
                        if (b?.isCompany === true && (b?.businessName?.length ?? 0) < 1) errors.billCompany = true;
                    }
                    break;
                }
                case "payment": {
                    if (this.payment === null || this.payment === undefined) {
                        errors.payment = true;
                    } else if (this.isWidgetPayment(this.payment) && this.loadedPaymentSig !== this.currentPaymentSig()) {
                        errors.loading = true; // widget not (re)loaded for the current state yet
                    }
                    break;
                }
            }
            return errors;
        },
        isSectionDone(name) {
            if (name === "user" && this.isLogged) {
                // logged in: done unless the CRM data is incomplete (terms are
                // accepted already)
                if (!this.loggedDataIncomplete) {
                    return true;
                }
                const errors = this.sectionErrors("user");
                delete errors.terms;
                return Object.keys(errors).length === 0;
            }
            if (name === "payment" && this.payment?.express) {
                return false;
            }
            return Object.keys(this.sectionErrors(name)).length === 0;
        },
        orderTab(back) {
            if(!back){
                this.shipping = null;
                this.deliveryType = null;
            }
            this.pageLoading = false;
            for (const item of this.items) {
                if(item.max === undefined){
                    this.pageLoading = true;
                    setTimeout(() => this.orderTab(),1000);
                    return;
                }
                if(item.max < item.quantity && item.preorder == 0){
                    this.stockError = true;
                    return;
                }
            }
            this.stockError = false;
            this.step = 2;
            this.compactCheckoutSections();
            this.autoSelectDelivery();
            // logged-in users: create the basket right when they enter the
            // checkout page (step 2), without waiting for the terms
            if (this.isLogged && (this.items?.length ?? 0) > 0 && (this.countryShipping?.id ?? "") !== "") {
                this.maybeCreateBasketEarly();
            }
            window.scrollTo({ top: 0, behavior: "smooth" });
            try {
                document.getElementsByTagName("header")[0].style.display = "none";
                document.getElementsByTagName("footer")[0].style.display = "none";
            } catch (error) {
                console.error("[cart] hide header/footer failed", error);
            }

            this.restoreChannelSwitch();
            if(!back) {
                const _this = this;
                setTimeout(() => {
                    forms.load();
                    try {
                        _this.validateShippingCountry();
                        _this.loadShipping(_this.countryShipping.id);
                    } catch (error) {
                        console.error("[cart] loadShipping failed", error);
                    }
                    _this.autoSelectDelivery();
                }, 100);
            }

            setTimeout(() => {
                const phoneInput = document.querySelector("#phone-cart");
                if (this.iti == null && phoneInput !== undefined && phoneInput !== null) {
                    this.iti = intlTelInput(phoneInput, {
                        separateDialCode: true,
                        initialCountry: user_country.toLowerCase() ?? "hu",
                        utilsScript: PHONE_UTILS,
                    });
                    attachPhoneFormat(this.iti, phoneInput);
                    // an international number (the CRM's) selects its country; the field then shows the rest (phoneShown)
                    const saved = String(this.userData?.phoneNumber ?? "").trim();
                    if (saved.charAt(0) === "+") {
                        try { this.iti.setNumber(saved); } catch (e) { /* the selector stays */ }
                    }
                    const rememberDial = () => { this.phoneDial = this.iti?.getSelectedCountryData()?.dialCode ?? ""; };
                    rememberDial();
                    phoneInput.addEventListener("countrychange", rememberDial);
                }
            }, 400);
        },
        modifyQuantity() {
            this.updateLocalStorage();
            this.refreshMemberDiscount();
        },
        canChangeQty(item) {
            return !(item.max !== undefined && item.max !== null && Number(item.quantity) >= Number(item.max));
        },
        canDecrement(item) {
            return Number(item.quantity) > 1;
        },
        canIncrementQty(item) {
            const max = item.max ?? 100;
            const stockChecked = item.max !== 0 && Number(item.quantity) < Number(max);
            return !(item.availability === 2) && stockChecked && Number(item.quantity) < 99;
        },
        stepQuantity(i, delta) {
            const item = this.items[i];
            const next = Number(item.quantity) + delta;
            const max = item.max ?? 100;
            if (next < 1 || next > 99) return;
            if (item.availability === 2 && delta > 0) {
                this.pushToast(lang?.cart?.messages?.preorder ?? "This product is available on pre-order only", "info");
                return;
            }
            if (next > Number(max)) {
                if (Number(max) <= 0) {
                    this.pushToast(lang?.cart?.messages?.not_stock ?? "This product is currently out of stock", "error");
                } else {
                    const msg = (lang?.cart?.messages?.max_quantity ?? "Maximum quantity: :qt")
                        .replace(":qt", String(max));
                    this.pushToast(msg, "error");
                }
                return;
            }
            this.items[i].quantity = next;
            this.modifyQuantity();
        },
        remove(i) {
            if (this.items === null || this.items === undefined) return;
            const removed = [...this.items].splice(i, 1)[0];
            this.items.splice(i, 1);
            this.refreshMemberDiscount();
            this.updateLocalStorage();
            this.pushToast(
                (lang?.cart?.item?.removed ?? "Item removed"),
                "success",
                () => {
                    if (removed !== undefined && removed !== null) {
                        this.items.splice(Math.min(i, this.items.length), 0, removed);
                        this.updateLocalStorage();
                    }
                }
            );
        },
        pushToast(message, type = "info", onUndo = null) {
            const toast = { id: Date.now() + Math.random(), message: String(message ?? ""), type, onUndo };
            (this.toasts ||= []).push(toast);
            setTimeout(() => this.dismissToast(toast.id), 6000);
        },
        dismissToast(id) {
            const index = (this.toasts ?? []).findIndex((toast) => toast.id === id);
            if (index > -1) this.toasts.splice(index, 1);
        },
        addToCart(target, image, name, price, curr, sku, serial){
            let _this = this;
            if (target !== null && typeof target === "object") {
                image = target.image?.src ?? target.image;
                name = target.name;
                price = target.price;
                sku = target.sku;
                serial = target.serial;
                target = target.id;
                curr = currency;
            }
            //HEADERCART.vue.addItem(id,price,1,null,name,image,null,null,null);
            const newItem = {
                id: target,
                name: name,
                price: price,
                currency: currency,
                image: image,
                quantity: 1,
                size: null,
                color: null,
                sku: sku,
                serial: serial,
                original_price: null,
                timeAdded: Date.now(),
            };

            this.items.push(newItem);
            this.checkProducts();
        },
        addToOrder(id,image,name,price,currency){
            this.pageLoading = true;
            fetch("/api/orders/item/"+this.order.id+"/add", {
                method: "POST",
                headers: http.headers(),
                body: JSON.stringify({
                    operation: 'add',
                    cart_token: this.order.cart_token,
                    productsToAdd: [{
                        id: id,
                        quantity: 1
                    }],
                    token: Cookies.getItem('login_token')
                }),

            }) .then((response) => response.json())
                .then((data) => {
                if(data.success) {
                    this.items.push({
                        color: "",
                        currency: currency,
                        id: id,
                        image: image,
                        name: name,
                        price: price,
                        quantity: 1,
                        size: "",
                        sku: "",
                        timeAdded: 0
                    });
                }
                this.pageLoading = false;
            });
        },
        updateLocalStorage() {
            storage.updateLocalStorage(this);
        },
        emptyLocalStorage() {
            storage.emptyLocalStorage(this);
        },
        checklogin() {
            customer.checklogin(this);
        },
        checkEmail() {
            customer.checkEmail(this);
        },
        guest() {
            customer.guest(this);
        },
        login() {
            customer.login(this);
        },
        getUserData() {
            customer.getUserData(this);
        },

        /* payments */
        loadScript(script, after = null,event=null) {
            const _this = this;
            const tag = document.createElement("script");
            tag.src = script;
            if (after !== undefined && after !== null) {
                tag.onload = () => {
                    _this.loadScript(after,null,event);
                };
            }else if (event !== undefined && event !== null) {
                tag.onload = () => {
                    event();
                };
            }
            document.getElementsByTagName("body")[0].appendChild(tag);
        },
        initializePaymentButton(event) {
            this.initializePaymentButtonEvent = event;
        },
        startInitializePaymentButton() {
            if(this.initializePaymentButtonEvent !== null){
                let countries = [];
                for (const option of this.paymentButtonSettings.countries) {
                    countries.push(option.code.toUpperCase());
                }

                this.initializePaymentButtonEvent({
                    price: this.totalPrice + (this.shippingPrice ?? 0),
                    currency_code: currency,
                    client_id: this.paymentButtonSettings.client_id,
                    // the payment app's own settings for its button script (Stripe: wallet_mode)
                    options: this.paymentButtonSettings.options ?? {},
                    countries: countries,
                });
            }
        },
        getDeliveryOptions() {
            for (const ship of this.paymentButtonSettings.shippings) {
                ship.price = this.shippingPrices(ship.prices,true);
            }

            // a country the wallet does not ship to (or none yet): the methods of its first one - without
            // changing the checkout's country, which the wallet's own address sets (changeCountry)
            const listed = this.paymentButtonSettings.countries.some((e) => e.id == this.countryShipping.id);
            const shipTo = listed ? this.countryShipping.id : this.paymentButtonSettings.countries[0]?.id;

            return this.paymentButtonSettings.shippings.filter((e) => e.prices.findIndex((g) => g.country_id == shipTo) > -1 );
        },
        startPayment(event) {
            this.startPaymentEvent[this.payment.id] = event;
            this.startPaymentCall();
        },
        startPaymentCall() {
            const stored = this.paymentData?.[this.payment?.id];
            const paymentInfo = stored?.original?.data ?? stored?.data ?? stored;
            if(this.startPaymentEvent[this.payment?.id] !== null && this.startPaymentEvent[this.payment?.id] !== undefined && paymentInfo !== undefined){
                history.pushState({page: "cart"}, "Cart", '/payment/'+this.order.id+'?token='+this.order.cart_token);
                if(document.getElementById("payment-element-"+paymentInfo.payment_method_id)?.innerHTML === "") {
                    this.startPaymentEvent[this.payment.id](paymentInfo, "payment-element-" + paymentInfo.payment_method_id);
                }
                this.pageLoading = false;
            }
        },
        getAddress(str) {
            var regex = /(?:\b(\d+[A-Za-z]*)(?:\s+(?:([^\d,]+)\s*)?([\dA-Za-z\/\s-]+)?)\b)|(?:\b(?:([^\d,]+)\s*)?([\dA-Za-z\/\s-]+)\b)/;

            var rs = regex.exec(str);

            if (!rs) {
                return {
                    street: str,
                    house: ""
                };
            }

            var street1 = rs[2] || "";
            var house2 = rs[5] || "";
            var street2 = rs[4] || "";
            var house1 = rs[1] || "";
            var street3 = rs[3] || "";

            return {
                street: (street1 + street2 + street3).trim(),
                house: (house1 + house2).trim(),
            };
        },
        finishPaymentButton(data,event) {
            this.finishPaymentButtonEvent = event;
            this.expressConfirming = true;

            let address = this.getAddress(data.shippingAddress.address.line1 + ' '+(data.shippingAddress.address.line2 ?? ""));
            let shipping = this.paymentButtonSettings.shippings.find((e) => e.id == data.shippingRate.id);
            if(address.house?.length < 1){
                this.pushToast(lang?.cart?.messages?.house_number_required ?? "House number required", "error");
            }
            this.shipping = shipping;
            this.countryShipping.code = data.shippingAddress.address.country;

            if(shipping.type == 2){
                this.mapPostCode = data.shippingAddress.address.postal_code ?? "";
                this.loadPackagePoints({methodId: shipping.id});
            }

            this.payment = {id: this.paymentButtonSettings.id, express: true};
            this.userData.email = data.billingDetails.email;
            this.userData.phoneNumber = (data.billingDetails.phone ?? "").replace(/[\s()\-.]/g, "");
            this.userData.firstName = data.billingDetails.name.split(' ').slice(0, -1).join(' ');
            this.userData.lastName = data.billingDetails.name.split(' ').slice(-1).join(' ');
            this.shipping = {id: data.shippingRate.id, type: shipping.type};
            this.savedShipping.city = data.shippingAddress.address.city ?? (data.shippingAddress.address.state ?? "");
            this.savedShipping.postcode = data.shippingAddress.address.postal_code ?? "";
            this.savedShipping.street = address.street;
            this.savedShipping.house = address.house;
            this.savedShipping.state = data.shippingAddress.address.state ?? (data.shippingAddress.address.region ?? "");
            this.savedShipping.area = this.countryShipping.needArea ? data.shippingAddress.address.line2 : "";

            this.invoice = 2;

            address = this.getAddress(data.billingDetails.address.line1 + ' '+(data.shippingAddress.address.line2 ?? ""));
            if(address.house?.length < 1){
                this.pushToast(lang?.cart?.messages?.house_number_required ?? "House number required", "error");
            }
            this.billAddress.postcode = data.billingDetails.address.postal_code ?? (data.shippingAddress.address.postal_code ?? "");
            this.billAddress.city = data.billingDetails.address.city ?? (data.billingDetails.address.state ?? (data.shippingAddress.address.state ?? ""));
            this.billAddress.street = address.street;
            this.billAddress.house = address.house;
            this.billAddress.state = data.billingDetails.address.state ?? (data.billingDetails.address.region ?? "");
            this.billAddress.area = this.countryShipping.needArea ? (data.billingDetails.address.line2 ?? data.shippingAddress.address.line2) : "";
            this.terms = true;

            if(this.savedShipping.city.length < 1){
                this.savedShipping.city = this.savedShipping.state;
            }
            if(this.billAddress.state.length < 1){
                this.billAddress.state = this.savedShipping.state;
            }
            if(this.billAddress.city.length < 1){
                this.billAddress.city = this.savedShipping.city;
            }

            if(this.order?.id > 0){
                this.initPayment();
            }else {
                this.paymentTab(true);
            }
        },
        callFinishPaymentButton() {
            const stored = this.paymentData?.[this.payment?.id];
            this.isInputLoding = true;
            this.finishPaymentButtonEvent(stored?.original?.data ?? stored?.data ?? stored).then(data => {
                this.expressConfirming = false;
                document.getElementsByTagName(
                    "header"
                )[0].style.display = "none";
                document.getElementsByTagName(
                    "footer"
                )[0].style.display = "none";
                this.step = 5;
                this.pageLoading = false;
                this.isInputLoding = false;
                // the wallet's purchase is measured like the card field's (before the items go: the event carries them)
                fetch("/api/event", {
                    method: "POST",
                    headers: http.headers(),
                    body: JSON.stringify({
                        eventId: window.AppEvents.getNextLoadId(),
                        payload: data,
                        event: "PURCHASE",
                        url: location.href,
                        orderId: this.order.id,
                    }),
                });
                this.emptyLocalStorage();
                this.items = [];
                window.scrollTo({ top: 0, behavior: "smooth" });
            }).catch(error => {
                this.paymentError = error.message;
                this.pageLoading = false;
                this.isInputLoding = false;
                this.expressConfirming = false;
            });
        },
        finishPayment(event) {
            this.finishPaymentEvent[this.payment.id] = event;
        },
        async callFinishPayment() {
            if (this.finishing) {
                return;
            }
            if(this.payment == null){
                this.paymentError = lang?.cart?.messages?.missing_payment ?? "Please select a payment method.";
                this.openCheckoutSections(['payment']);
                return;
            }
            if(!this.payment.express && this.checkOrder()){
                // checkOrder opened the sections with errors - keep them open
                return;
            }
            this.finishClickedAt = Date.now();
            // isDirty: every change has to be saved before the order is finished
            this.finishing = true;
            let saved = false;
            try {
                saved = await this.ensureCheckoutSaved();
            } finally {
                this.finishing = false;
            }
            if (!saved) {
                if (!this.paymentError) {
                    this.paymentError = lang?.cart?.messages?.payment_updating ?? "Updating your payment, please wait...";
                }
                this.openCheckoutSections(['payment']);
                return;
            }
            if(this.isOfflinePayment(this.payment)){
                // COD / bank transfer: the order is created on Finish
                // explicitly - no loading state, nothing runs on selection
                this.finishRequestMode = true;
                this.finishOrder(5, true);
                return;
            }
            // redirect payment: create the order+payment on Finish, then the
            // payment flow must send the user to the redirect url
            if(this.isRedirectPayment(this.payment)){
                this.finishRequestMode = true;
                if(this.order?.id > 0){
                    this.initPayment();
                }else{
                    this.finishOrder(4, true);
                }
                return;
            }
            if(this.finishPaymentEvent[this.payment.id] === undefined){
                this.paymentError = lang?.cart?.messages?.missing_payment ?? "Please select a payment method.";
                this.openCheckoutSections(['payment']);
                this.focusFirstInvalid();
                return;
            }
            // a closed block hides the card field and its errors: open it before the widget answers
            if (this.hasCardField(this.payment) && !this.checkoutSections.payment) {
                this.showPaymentCard(false);
            }
            this.isInputLoding = true;
            this.finishPaymentEvent[this.payment.id]().then(data => {
                this.step = 5;
                window.scrollTo({ top: 0, behavior: "smooth" });
                this.isInputLoding = false;
                fetch("/api/event", {
                    method: "POST",
                    headers: http.headers(),
                    body: JSON.stringify({
                        eventId: window.AppEvents.getNextLoadId(),
                        payload: data,
                        event: "PURCHASE",
                        url: location.href,
                        orderId: this.order.id,
                    }),
                });
                window.scrollTo({ top: 0, behavior: "smooth" });
                this.emptyLocalStorage();
            }).catch(data => {
                this.paymentError = data?.message;
                this.isInputLoding = false;
                if (this.hasCardField(this.payment)) {
                    this.showPaymentCard(true);
                }
            });
        },
        selectCountry(event) {
            this.countryPicked = true;
            address.selectCountry(this, event);
        },
        // a country of this channel's currency (the country field)
        pickCountry(row) {
            this.countryShipping.id = isNaN(Number(row.id)) ? row.id : Number(row.id);
            this.selectCountry({target: {value: String(row.id)}});
        },
        // another currency = another sale channel: the contact details go with the customer (this tab only),
        // the cart is the browser's own and the new channel prices it
        switchChannel(row) {
            const ud = this.userData ?? {};
            try {
                sessionStorage.setItem(CHANNEL_CARRY, JSON.stringify({
                    t: Date.now(), country: row.id, from: String(this.cartConfig?.currencyCode ?? ""),
                    first: ud.firstName ?? "", last: ud.lastName ?? "", email: ud.email ?? "",
                    phone: this.iti?.isValidNumber?.() ? this.iti.getNumber() : "",
                }));
            } catch (e) { /* it switches without the details */ }
            document.cookie = "ship_country=" + encodeURIComponent(row.id) + "; max-age=" + (365 * 24 * 3600) + "; path=/; samesite=lax";
            window.location.href = row.url + (String(row.url).includes("?") ? "&" : "?") + "checkout=1";
        },
        // on the new channel: the details back into the state (once), the country selected
        restoreChannelSwitch() {
            let carry = null;
            try {
                carry = JSON.parse(sessionStorage.getItem(CHANNEL_CARRY) || "null");
                sessionStorage.removeItem(CHANNEL_CARRY);
            } catch (e) { carry = null; }
            if (!carry || Date.now() - Number(carry.t || 0) > 15 * 60 * 1000) return;
            // back on the same currency (e.g. the browser's back button): nothing to restore
            if (String(carry.from) === String(this.cartConfig?.currencyCode ?? "")) return;
            const ud = this.userData;
            if (!ud.firstName && carry.first) ud.firstName = carry.first;
            if (!ud.lastName && carry.last) ud.lastName = carry.last;
            if (!ud.email && carry.email) ud.email = carry.email;
            // an international number: the phone field picks its country from it
            if (!ud.phoneNumber && carry.phone) ud.phoneNumber = carry.phone;
            if ((this.cartConfig?.countries ?? []).some((c) => String(c.id) === String(carry.country))) {
                this.countryShipping.id = isNaN(Number(carry.country)) ? carry.country : Number(carry.country);
                this.countryPicked = true;
            }
            this.channelNote = String(window.COUNTRY_TEXTS?.kept ?? "").replace(":currency", String(this.cartConfig?.currencyCode ?? ""));
        },
        selectInvoiceCountry(event){
            address.selectInvoiceCountry(this, event);
        },
        defaultInvoiceCountry() {
            const invoiceCountries = this.invoiceCountryOptions;
            if (this.userData.countryID == "" || this.userData.countryID == null || !invoiceCountries.some((item) => String(item.id) === String(this.userData.countryID))) {
                this.userData.countryID = this.countryShipping.id;
            }
            if (!invoiceCountries.some((item) => String(item.id) === String(this.userData.countryID))) {
                this.userData.countryID = invoiceCountries[0]?.id ?? this.userData.countryID;
            }
            const element = invoiceCountries.find((item) => String(item.id) === String(this.userData.countryID));
            if (element) {
                this.countryInvoice.id = element.id;
                this.countryInvoice.code = element.code;
                this.countryInvoice.needPost = element.need_post_code;
                this.countryInvoice.needArea = element.need_area;
                this.countryInvoice.is_eu = element.is_eu;
                this.countryInvoice.postLocalName = element.post_code_local_name;
                this.countryInvoice.addressStyle = element.address_style;
                this.countryInvoice.needState = element.need_state;
                this.countryInvoice.stateType = element.state_type;
                this.countryInvoice.postRegex = element.post_code_regex;
                this.countryInvoice.houseRegex = element.house_regex;
            }
        },
        // the wallet's address (Apple / Google Pay): her country
        changeCountry(code) {
            this.countryPicked = true;
            address.changeCountry(this, code);
        },
        loadShipping(value) {
            address.loadShipping(this, value);
            this.markDeliveryChanged();
        },
        initPayment() {
            // COD/redirect methods have no payment widget - init-payment is
            // only triggered by the explicit Finish flow (finishRequestMode),
            // never by background re-inits (delivery/coupon changes)
            if (this.isCODOrRedirect(this.payment) && !this.finishRequestMode) {
                return Promise.resolve();
            }
            if (this.initPaymentPromise) {
                if (this.syncRunning) {
                    this.syncDirty = true; // re-check with the latest state afterwards
                }
                if (this.initPaymentMethodId !== null && this.initPaymentMethodId !== this.payment.id) {
                    // the request on its way starts another method's payment (the customer chose again): its answer is
                    // not this method's - ask for this one after it (a COD "confirmation" must never come from a
                    // card payment's answer)
                    return this.initPaymentPromise.then(() => this.initPayment());
                }
                return this.initPaymentPromise;
            }
            const signature = this.currentPaymentSig();
            const requestedPayment = this.payment;
            this.initPaymentMethodId = requestedPayment.id;
            const element = document.getElementById("payment-element-" + this.payment.id);
            if (element && element.innerHTML !== "" && this.loadedPaymentSig === signature) {
                this.pageLoading = false;
                return Promise.resolve();
            }
            if (this.isWidgetPayment(this.payment)) {
                this.creatingOrderSilent = true;
            }
            this.initPaymentPromise = fetch("/api/orders/" + this.order.id + "/init-payment", {
                method: "POST",
                headers: http.headers(),
                body: JSON.stringify({payment_method: this.payment.id, cart_token: this.order.cart_token}),
            })
                .then((response) => response.json().catch(() => null).then((data) => ({ok: response.ok, status: response.status, data})))
                .then(({ok, status, data}) => {
                    if (this.reloadWhenOrderGone(status, data)) {
                        return;
                    }
                    if (this.payment?.id !== requestedPayment.id) {
                        // the customer chose another method meanwhile: this answer is not for it (the new method's
                        // request follows, see above)
                        return;
                    }
                    if (data?.success === false || (data?.code ?? 200) >= 400) {
                        // e.g. 409: a payment of this order is already in progress
                        this.paymentError = data?.message ?? null;
                        this.finishRequestMode = false;
                        this.pageLoading = false;
                        return;
                    }
                    if (!ok || data === null) {
                        // 5xx / 422 / non-JSON body carry no success or code field:
                        // never the confirmation for a payment the backend did not take
                        this.showPaymentStartError();
                        return;
                    }
                    if (this.paymentStartFailed(data)) {
                        // the provider rejected the start: never the confirmation
                        this.showPaymentStartError();
                        return;
                    }
                    if(this.paymentButtonSettings?.id === this.payment.id){
                        this.paymentData[this.payment.id] = data.payment;
                        this.callFinishPaymentButton();
                    }else if(this.isOfflinePayment(this.payment)){
                        this.finishRequestMode = false;
                        this.pageLoading = false;
                        this.offlineOrderPlaced(data);
                        this.step = 5;
                        window.scrollTo({ top: 0, behavior: "smooth" });
                        this.emptyLocalStorage();
                    }else{
                        this.step = 4;
                        this.paymentData[this.payment.id] = data.payment;
                        if (this.isWidgetPayment(this.payment)) {
                            this.loadedPaymentSig = signature;
                            this.loadedAmount = this.paymentInfo(data?.payment)?.price ?? null;
                        }
                        // redirect payment: go to the PSP payment page
                        const redirectUrl = this.paymentInfo(data?.payment)?.redirect_url;
                        this.finishRequestMode = false;
                        if (redirectUrl) {
                            this.pageLoading = true; // keep the overlay during navigation
                            window.location.href = redirectUrl;
                            return;
                        }
                        // background init: no page scroll on method selection
                        setTimeout(() => this.startPaymentCall(), 300);

                        if (
                            data?.script?.url !== undefined &&
                            data?.script?.url !== null &&
                            data?.script?.script !== undefined &&
                            data?.script?.script !== null &&
                            data?.script?.url !== ""
                        ) {
                            this.loadScript(
                                data.script.url,
                                "/api/script/" + data.script.id + ".js"
                            );
                        } else if (
                            data?.script?.url !== undefined &&
                            data?.script?.url !== null &&
                            data?.script?.url !== ""
                        ) {
                            this.loadScript(data.script.url);
                        } else if (
                            data?.script?.script !== undefined &&
                            data?.script?.script !== null
                        ) {
                            this.loadScript(
                                "/api/script/" + data.script.id + ".js"
                            );
                        } else {
                            this.pageLoading = false;
                            this.addMore = true;
                            this.step = 5;
                            window.scrollTo({ top: 0, behavior: "smooth" });
                            this.emptyLocalStorage();
                        }
                    }
                })
                .catch(() => {
                    this.pageLoading = false;
                })
                .finally(() => {
                    this.initPaymentPromise = null;
                    this.initPaymentMethodId = null;
                    this.creatingOrderSilent = false;
                });
            return this.initPaymentPromise;
        },
        /**
         * nextStep: 4 = payment view handled by data handler, 5 = confirmation
         * silent: background draft creation (one-page checkout) - no full-page
         * loading overlay, the payment element area shows a skeleton instead
         */
        finishOrder(nextStep = 4, silent = false) {
            if(!silent){
                this.pageLoading = true;
            }
            if(this.order?.id > 0){
                return this.initPayment();
            }
            return this.createOrderOnce(silent).then((data) => {
                if (data === null) {
                    this.finishRequestMode = false;
                    this.pageLoading = false;
                    return;
                }
                this.handleCreatedOrder(data, nextStep);
            });
        },
        /**
         * Creates the order - at most once: concurrent callers (background sync,
         * Finish button) share the same request. Resolves the response data, or
         * null when the order was rejected (the error is shown, the same data is
         * not sent again).
         */
        createOrderOnce(silent = true) {
            if (this.orderCreatePromise) {
                return this.orderCreatePromise;
            }
            if (silent && !this.isCODOrRedirect(this.payment)) {
                // widget methods get the in-place skeleton; COD/redirect show
                // nothing while the order is being created
                this.creatingOrderSilent = true;
            }
            this.creatingOrder = true;
            // a running basket creation must land first - the order is created
            // from that basket (never a second one from the items)
            const basketReady = this.basketCreatingPromise ?? Promise.resolve(true);
            this.orderCreatePromise = basketReady.then(() => {
                const signature = this.draftCreateSignature();
                const deliverySig = this.deliverySignature();
                const customerSig = this.customerSignature();
                const itemsSig = this.itemsSignature();
                const createdPayment = this.payment ? {id: this.payment.id, type: this.payment.type} : null;
                if (this.invoice == 1) this.billAddress = this.savedShipping;
                if (this.invoice == 3) this.billAddress = this.userBill;

                let token = Cookies.getItem("login_token");
                let bodyContent = {
                    load_id: window.AppEvents.getNextLoadId(),
                    url: location.href,
                    token: token || "",
                    basket_token: this.basket.token || "",
                    payment_method: this.payment?.id || "",
                    country_id: this.userData.countryID || this.countryShipping.id,
                    email: this.userData.email || "",
                    phone: this.phoneForBackend() || this.backendPhone || this.userData.phoneNumber || "",
                    first_name: this.userData.firstName || "",
                    last_name: this.userData.lastName || "",
                    currency: currency,
                    delivery_comment: this.deliveryComment || "",
                    shop_comment: this.shopComment || "",
                    delivery: {
                        method: this.shipping.id || "",
                        country_id: this.countryShipping.id || "",
                        post_code: this.savedShipping.postcode || "",
                        city: this.savedShipping.city || "",
                        street: this.savedShipping.street || "",
                        state: this.savedShipping.state || "",
                        area: this.savedShipping.area || "",
                        house: this.savedShipping.house || "",
                        package_point: this.savedShipping.package_point || "",
                        extra_data: this.extraField ? (this.savedShipping.extra_data || "").trim() : "",
                    },
                    type: this.billAddress.businessName ? 1 : 0,
                    business_name: this.billAddress.businessName || "",
                    invoice_post_code: this.billAddress.postcode || "",
                    invoice_city: this.billAddress.city || "",
                    invoice_street: this.billAddress.street || "",
                    invoice_house: this.billAddress.house || "",
                    invoice_state: this.billAddress.state || "",
                    invoice_area: this.billAddress.area || "",
                    tax_code: this.userData.taxCode || (this.billAddress.taxNumber ?? ""),
                    eu_tax_code:
                        this.userData.euTaxCode || (this.billAddress.euTaxNumber ?? ""),
                    utm_source: sessionStorage.getItem("utm_source") ?? "",
                    utm_medium: sessionStorage.getItem("utm_medium") ?? "",
                    utm_campaign: sessionStorage.getItem("utm_campaign") ?? "",
                    utm_content: sessionStorage.getItem("utm_content") ?? "",
                    utm_term: sessionStorage.getItem("utm_term") ?? "",
                    referrer: sessionStorage.getItem("referrer") ?? "",
                };

                // coupon applied at creation time - later coupon changes go
                // through the /order/{id}/coupon endpoint (checkout sync)
                const createdCoupon = (this.validatedCoupon ?? "").length > 1 ? this.validatedCoupon : "";
                if(createdCoupon !== ""){
                    bodyContent.coupon = createdCoupon;
                }

                if(!this.hasBasket()) {
                    let counter = 0;
                    bodyContent.items = [];
                    this.items.forEach((elem) => {
                        bodyContent.items[counter] = {
                            id: elem.id,
                            quantity: elem.quantity,
                        };
                        counter++;
                    });
                }


                return fetch("/api/order/create/" + (this.basket.id ?? ""), {
                    method: "POST",
                    headers: http.headers(),
                    body: JSON.stringify(bodyContent),
                })
                    .then((response) => response.json())
                    .then((data) => {
                        if (data.code !== 200 || data?.errors?.length > 0) {
                            this.failedCreateSignature = signature;
                            this.showOrderCreateError(data);
                            return null;
                        }
                        this.failedCreateSignature = null;
                        this.clearOrderCreateError();
                        this.basketError = null;
                        this.basketItemError = false;
                        this.order = data.data;
                        this.createdPayment = createdPayment;
                        this.syncedDeliverySig = deliverySig;
                        this.syncedCustomerSig = customerSig;
                        this.orderItemsSig = itemsSig;
                        this.syncedCoupon = createdCoupon;
                        this.orderCouponApplied = createdCoupon !== "";
                        return data;
                    });
            })
                .catch((error) => {
                    console.error("[cart] order creation failed", error);
                    return null;
                })
                .finally(() => {
                    this.orderCreatePromise = null;
                    this.creatingOrder = false;
                    this.creatingOrderSilent = false;
                    this.finishRequestMode = false;
                });
            return this.orderCreatePromise;
        },
        /**
         * Rejected order creation (e.g. 422): the message goes to the payment
         * section (visible in the one-page checkout) and the sections holding
         * the invalid fields are opened.
         */
        showOrderCreateError(data) {
            // field errors are localized - the generic (english) validation
            // message is only shown when there are none
            const fieldErrors = [];
            const sections = [];
            for (const field in (data?.errors ?? {})) {
                fieldErrors.push(...[].concat(data.errors[field]));
                if (["email", "phone", "first_name", "last_name"].includes(field)) {
                    sections.push("user");
                } else if (field.startsWith("delivery")) {
                    sections.push("delivery");
                } else if (field.startsWith("invoice_") || ["tax_code", "eu_tax_code", "business_name"].includes(field)) {
                    sections.push("billing");
                }
            }
            this.errorPaymentMethod = (fieldErrors.length > 0 ? fieldErrors.join(" ") : (data?.message ?? "")).trim();
            this.paymentError = this.errorPaymentMethod;
            if (sections.length > 0) {
                this.openCheckoutSections([...new Set(sections)]);
            }
            if(this.paymentButtonSettings?.id === this.payment?.id) {
                this.pageLoading = false;
            }
        },
        clearOrderCreateError() {
            if (this.errorPaymentMethod !== null && this.paymentError === this.errorPaymentMethod) {
                this.paymentError = null;
            }
            this.errorPaymentMethod = null;
        },
        // the start-payment result is wrapped: {payment: {original: {success}}}
        paymentStartFailed(data) {
            return data?.payment?.original?.success === false || data?.payment?.success === false;
        },
        showPaymentStartError() {
            this.paymentError = lang?.cart?.messages?.payment_start_failed
                ?? "The payment could not be started. Please try again or choose another payment method.";
            this.finishRequestMode = false;
            this.pageLoading = false;
            this.isInputLoding = false;
            this.openCheckoutSections(["payment"]);
            this.focusFirstInvalid();
        },
        // the order was created with an online (widget / redirect) method other
        // than the selected one
        createdWithOtherPayment() {
            const created = this.createdPayment;
            return created !== null && this.payment !== null
                && !this.isOfflinePayment(created)
                && String(created.id) !== String(this.payment.id);
        },
        handleCreatedOrder(data, nextStep) {
            if(this.paymentButtonSettings?.id === this.payment?.id) {
                this.paymentData[this.payment.id] = data.payment;
                this.callFinishPaymentButton();
            }else if (!this.isOfflinePayment(this.payment) && this.paymentStartFailed(data)) {
                // order created, but its payment did not start (e.g. redirect PSP)
                this.showPaymentStartError();
            }else if(this.isOfflinePayment(this.payment) || nextStep == 5){
                    // edge case: the background draft was created with a widget
                    // method and COD / bank transfer was chosen while it was
                    // running - that order is not placed: no confirmation, the
                    // selected method replaces its payment (on Finish)
                    if (this.createdWithOtherPayment()) {
                        this.step = 4;
                        this.pageLoading = false;
                        if (nextStep == 5) {
                            this.finishRequestMode = true;
                            this.initPayment();
                        }
                        return;
                    }
                    this.pageLoading = false;
                    this.offlineOrderPlaced(data);
                    this.step = 5;
                    window.scrollTo({ top: 0, behavior: "smooth" });
                    this.emptyLocalStorage();
            }else {
                this.step = 4;

                // edge case: the payment method was switched while the
                // creation was running - re-init with the selected one
                const createdMethodId = this.paymentInfo(data?.payment)?.payment_method_id;
                if (this.payment?.id !== undefined && createdMethodId !== undefined
                    && String(this.payment.id) !== String(createdMethodId)) {
                    if (!this.syncRunning) {
                        this.initPayment();
                    }
                    return;
                }
                this.paymentData[this.payment.id] = data.payment;
                if (createdMethodId !== undefined && this.isWidgetPayment(this.payment)) {
                    this.loadedPaymentSig = this.currentPaymentSig(createdMethodId);
                    this.loadedAmount = this.paymentInfo(data?.payment)?.price ?? null;
                }

                // redirect payment: go to the PSP payment page
                const redirectUrl = this.paymentInfo(data?.payment)?.redirect_url;
                if (redirectUrl) {
                    window.location.href = redirectUrl;
                    return;
                }
                // background creation: no page scroll on method selection
                setTimeout(() => this.startPaymentCall(), 300);

                if (
                    data?.script?.url !== undefined &&
                    data?.script?.url !== null &&
                    data?.script?.script !== undefined &&
                    data?.script?.script !== null &&
                    data?.script?.url !== ""
                ) {
                    this.loadScript(
                        data.script.url,
                        "/api/script/" + data.script.id + ".js"
                    );
                } else if (
                    data?.script?.url !== undefined &&
                    data?.script?.url !== null &&
                    data?.script?.url !== ""
                ) {
                    this.loadScript(data.script.url);
                } else if (
                    data?.script?.script !== undefined &&
                    data?.script?.script !== null
                ) {
                    this.loadScript(
                        "/api/script/" + data.script.id + ".js"
                    );
                } else {
                    this.pageLoading = false;
                }
            }
        },
        selectPointFromList(index) {
            if (index === undefined) {
                index = this.points.findIndex((p) => String(p.pointId) === String(this.savedShipping.package_point));
                if (index < 0) return;
            }
            const point = this.points[index];
            if (!point) return;
            this.latitude = Number.parseFloat(point.geolat);
            this.longitude = Number.parseFloat(point.geolon);
            this.zoom = 15;
            this.selectPoint(point);
        },
        pointAvailable(point) {
            const method = this.pointMethod(point);
            if (!method || (point?.postCode ?? "") === "") {
                return true;
            }
            return this.methodPricesForAddress(method, point.postCode).length > 0;
        },
        pointMethod(point) {
            if (!point) {
                return null;
            }
            const methods = this.cartConfig.deliveryMethods ?? [];
            let method = null;
            if (point.method_id) {
                method = methods.find(
                    (m) => Number(m.type) === 2 && String(m.id) === String(point.method_id)
                ) ?? null;
            }
            if (!method) {
                method = methods.find(
                    (m) => Number(m.type) === 2 && String(m.country_id) === String(this.countryShipping.id)
                ) ?? null;
            }
            if (!method && Number(this.shipping?.type) === 2) {
                method = this.shipping;
            }
            if (!method && Array.isArray(point.prices) && point.prices.length > 0) {
                method = { type: 2, prices: point.prices };
            }
            return method;
        },
        selectPoint(point) {
            if (point?.method_id && (!this.shipping || Number(this.shipping.type) === 2 && String(this.shipping.id) !== String(point.method_id))) {
                const method = (this.countryDeliveryMethods ?? []).find(
                    (m) => Number(m.type) === 2 && String(m.id) === String(point.method_id)
                );
                if (method) {
                    this.shipping = method;
                }
            }
            this.selectedPoint = point;
            this.savedShipping.package_point = point.pointId;
            this.savedShipping.postcode = point.postCode;
            this.savedShipping.city = point.city;
            this.savedShipping.street = point.street;
            this.savedShipping.house = "";
            this.savedShipping.state = "";
            this.savedShipping.area = "";
        },
        // after the DOM update (also works outside a mounted component)
        afterRender(fn) {
            return typeof this.$nextTick === "function" ? this.$nextTick(fn) : setTimeout(fn, 0);
        },
        distanceKm(lat1, lon1, lat2, lon2) {
            const rad = (value) => value * Math.PI / 180;
            const dLat = rad(lat2 - lat1);
            const dLon = rad(lon2 - lon1);
            const a = Math.sin(dLat / 2) ** 2 + Math.cos(rad(lat1)) * Math.cos(rad(lat2)) * Math.sin(dLon / 2) ** 2;
            return 6371 * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        },
        /**
         * The map stopped moving: the list is re-ordered by the new centre; when
         * the user moved away from the loaded area, the points of what they
         * see are loaded (without moving the map).
         */
        onMapIdle(view) {
            this.mapCenter = {lat: view.lat, lng: view.lng};
            if (this.scrollToSelectionAfterIdle && this.selectedPoint) {
                // the list re-ordered around the selected point: keep it in view
                this.scrollToSelectionAfterIdle = false;
                this.scrollPointRowIntoView(this.selectedPoint);
            }
            const area = this.pointsLoadedArea;
            if (!area || this.pointsLoading) {
                return;
            }
            const moved = this.distanceKm(area.lat, area.lng, view.lat, view.lng);
            if (moved > Math.max(area.radiusKm * 0.6, 1)) {
                clearTimeout(this.pointsReloadTimer);
                this.pointsReloadTimer = setTimeout(() => {
                    this.loadPackagePoints({lat: view.lat, lon: view.lng, keepView: true});
                }, 500);
            }
        },
        // point icon with a neutral fallback when the carrier icon is missing
        pointIcon(point) {
            return point?.icon || POINT_ICON_FALLBACK;
        },
        onPointIconError(event) {
            if (event.target.src !== POINT_ICON_FALLBACK) {
                event.target.src = POINT_ICON_FALLBACK;
            }
        },
        selectPointFromRow(point) {
            this.selectPoint(point);
            this.focusPointOnMap(point);
        },
        selectPointFromMap(point) {
            this.selectPoint(point);
            this.scrollToSelectionAfterIdle = true;
            this.focusPointOnMap(point);
            this.scrollPointRowIntoView(point);
        },
        focusPointOnMap(point) {
            const lat = Number.parseFloat(point?.geolat);
            const lng = Number.parseFloat(point?.geolon);
            if (Number.isNaN(lat) || Number.isNaN(lng)) return;
            this.latitude = lat;
            this.longitude = lng;
            this.zoom = Math.max(Number(this.zoom) || 0, 15);
        },
        scrollPointRowIntoView(point) {
            this.afterRender(() => {
                const row = document.querySelector('.point-row[data-point-id="' + CSS.escape(String(point?.pointId)) + '"]');
                row?.scrollIntoView({block: "nearest", behavior: "smooth"});
            });
        },
        /**
         * Modal keyboard handling (WCAG 2.1.2 / 2.4.3): Escape closes, Tab stays
         * inside the dialog.
         */
        onModalKeydown(event, close) {
            if (event.key === "Escape") {
                event.preventDefault();
                close();
                return;
            }
            if (event.key !== "Tab") return;
            const box = event.currentTarget.querySelector(".co-modal-box") ?? event.currentTarget;
            const focusable = Array.from(box.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'))
                .filter((el) => !el.disabled && el.offsetParent !== null);
            if (focusable.length < 1) return;
            const first = focusable[0];
            const last = focusable[focusable.length - 1];
            if (event.shiftKey && document.activeElement === first) {
                event.preventDefault();
                last.focus();
            } else if (!event.shiftKey && document.activeElement === last) {
                event.preventDefault();
                first.focus();
            }
        },
        focusModal(selector) {
            this.afterRender(() => {
                const box = document.querySelector(selector);
                // touch: the dialog itself gets the focus (a screen reader is in it), not its first field - the
                // on-screen keyboard opens only when the customer taps a field
                if (box && window.matchMedia("(hover: none) and (pointer: coarse)").matches) {
                    if (!box.hasAttribute("tabindex")) box.setAttribute("tabindex", "-1");
                    box.focus({preventScroll: true});
                    return;
                }
                const target = box?.querySelector("input") ?? box?.querySelector("button") ?? box;
                target?.focus?.();
            });
        },
        restoreModalFocus() {
            const opener = this.modalReturnFocus;
            this.modalReturnFocus = null;
            this.afterRender(() => {
                // opened by a non-focusable element (e.g. a card click): back to
                // the delivery choice instead of the page start
                const usable = opener && opener !== document.body && document.contains(opener);
                const target = usable ? opener : document.querySelector(
                    '[data-checkout-section="delivery"] .point-picker-btn, [data-checkout-section="delivery"] input[type=radio]:checked'
                );
                target?.focus?.({preventScroll: true});
            });
        },
        loadPackagePoints({city = null, lat = null, lon = null, methodId = null, keepView = false} = {}) {
            if (Number(this.deliveryType) !== 2 && Number(this.shipping?.type) !== 2) {
                return;
            }
            this.pointsLoading = true;
            const groupedPointFlow = Boolean(this.cartConfig?.groupDeliveryMethods);
            let url = "/api/package-points/" + (groupedPointFlow ? (methodId ?? 'all') : (methodId ?? this.shipping.id ?? 'all')) + "/" + this.countryShipping.code;
            const query = [];
            if (lat !== null && lon !== null) {
                query.push("lat=" + lat, "lon=" + lon);
            } else if (city) {
                query.push("city=" + encodeURIComponent(city));
            } else if (this.mapPostCode) {
                url += "/" + encodeURIComponent(this.mapPostCode);
            }
            if (query.length) {
                url += "?" + query.join("&");
            }
            if (this.pointsLoading && this.pointsRequestUrl === url) {
                return; // the same list is already being loaded
            }
            this.pointsRequestUrl = url;
            fetch(url, {headers: http.headers()})
                .then((response) => response.json())
                .then((data) => {
                    this.points = data.list ?? [];
                    const centerLat = lat ?? Number.parseFloat(data.latitude);
                    const centerLng = lon ?? Number.parseFloat(data.longitude);
                    // the area the list covers: reload once the map leaves it
                    const radiusKm = this.points.reduce((max, point) => Math.max(max,
                        this.distanceKm(centerLat, centerLng, Number(point.geolat), Number(point.geolon)) || 0), 0);
                    this.pointsLoadedArea = {lat: centerLat, lng: centerLng, radiusKm: radiusKm || 5};
                    if (!keepView) {
                        this.latitude = Number.parseFloat(data.latitude);
                        this.longitude = Number.parseFloat(data.longitude);
                        this.zoom = 14;
                        this.mapCenter = null;
                    }
                })
                .catch((error) => {
                    console.log("package points error", error);
                })
                .finally(() => {
                    this.pointsLoading = false;
                    this.pointsRequestUrl = null;
                });
        },
        setPointCarrier(carrier) {
            this.pointCarrier = String(carrier || "");
            const list = document.querySelector(".point-modal-box .point-list");
            if (list) list.scrollTop = 0;
        },
        /* The pull-up list (phones): two heights, half and tall. The handle and the title, and the list too, are
           draggable: in the half state dragging the list moves the sheet, in the tall state only when the list is at
           its top and the drag goes down - like the Apple Maps sheet. On release the speed (0.4 px/ms) or the nearer
           height decides; past the limits it gives rubber-like (x0.3). The CSS owns the two heights, the state and the
           drag height come from data-vv-sheet / --vv-sh on the box. */
        pointSheetPhone() {
            return window.matchMedia("(max-width: 47.999em)").matches;
        },
        pointSheetSizes(box) {
            const H = box.clientHeight;
            const field = box.querySelector(".point-modal-search .co-field");
            const top = field ? field.getBoundingClientRect().bottom - box.getBoundingClientRect().top + 10 : 120;
            return {half: Math.round(H * 0.5), tall: Math.round(H - top)};
        },
        togglePointSheet() {
            if (this._sheetSuppress) return;
            this.pointSheet.state = this.pointSheet.state === "tall" ? "half" : "tall";
            this.pointSheet.height = null;
        },
        sheetTouchStart(e) {
            if (!this.pointSheetPhone() || e.touches.length !== 1) return;
            const box = e.currentTarget;
            const target = e.target;
            const handle = target.closest(".point-sheet-grip, .point-sheet-head");
            const list = target.closest(".point-list");
            if (!handle && !list) return;
            const sizes = this.pointSheetSizes(box);
            const sheet = box.querySelector(".point-sheet");
            const y = e.touches[0].clientY;
            this._sheetDrag = {box, sizes, list: list || null, mode: handle ? "handle" : "list", y0: y, h0: sheet ? sheet.getBoundingClientRect().height : sizes.half, samples: [[performance.now(), y]], moved: false};
        },
        sheetTouchMove(e) {
            const d = this._sheetDrag;
            if (!d) return;
            const y = e.touches[0].clientY;
            const rubber = (h) => h > d.sizes.tall ? d.sizes.tall + (h - d.sizes.tall) * 0.3 : (h < d.sizes.half ? d.sizes.half - (d.sizes.half - h) * 0.3 : h);
            if (d.mode === "list" && !d.moved) {
                const dy = y - d.y0;
                if (Math.abs(dy) < 6) return;
                const tall = this.pointSheet.state === "tall";
                const atTop = d.list.scrollTop <= 0;
                // half: the list moves the sheet; tall: only at the top and downwards - otherwise the list scrolls
                if (!(tall ? (atTop && dy > 0) : (dy < 0 || atTop))) { this._sheetDrag = null; return; }
                // from here the gesture is ours at once (iOS would take it for a scroll and cancel it)
                d.y0 = y;
                d.moved = true;
                this.pointSheet.dragging = true;
                if (e.cancelable) e.preventDefault();
                return;
            }
            const dy = y - d.y0;
            if (!d.moved) {
                if (Math.abs(dy) < 6) return;
                d.moved = true;
                this.pointSheet.dragging = true;
            }
            this.pointSheet.height = Math.round(rubber(d.h0 - dy));
            d.samples.push([performance.now(), y]);
            if (d.samples.length > 6) d.samples.shift();
            if (e.cancelable) e.preventDefault();
        },
        sheetTouchEnd() {
            const d = this._sheetDrag;
            this._sheetDrag = null;
            if (!d || !d.moved) return;
            this.pointSheet.dragging = false;
            const [t0, y0] = d.samples[0];
            const [t1, y1] = d.samples[d.samples.length - 1];
            const v = t1 > t0 ? (y1 - y0) / (t1 - t0) : 0; // + is downwards
            const h = this.pointSheet.height ?? d.h0;
            this.pointSheet.state = v < -0.4 ? "tall" : (v > 0.4 ? "half" : (h > (d.sizes.half + d.sizes.tall) / 2 ? "tall" : "half"));
            this.pointSheet.height = null;
            this._sheetSuppress = true;
            setTimeout(() => { this._sheetSuppress = false; }, 350);
        },
        // phone map: one finger moves it (Google asks for two when the page could scroll), without its own controls
        tunePointMap(tries = 0) {
            if (!this.pointPickerOpen || !this.pointSheetPhone()) return;
            const gmap = this.$refs.map && this.$refs.map.map;
            if (gmap && typeof gmap.setOptions === "function") {
                gmap.setOptions({gestureHandling: "greedy", disableDefaultUI: true, clickableIcons: false});
                return;
            }
            if (tries < 60) setTimeout(() => this.tunePointMap(tries + 1), 250);
        },
        openPointPicker() {
            this.pointCarrier = "";
            this.pointSheet = {state: "half", height: null, dragging: false};
            this.$nextTick(() => this.tunePointMap());
            this.activateSection('delivery');
            this.modalReturnFocus = document.activeElement;
            this.pointPickerOpen = true;
            this.focusModal(".point-modal-box");
            if (this.points.length === 0 && (this.mapPostCode || "").length > 0) {
                this.searchPackagePoints();
            }
        },
        closePointPicker() {
            this.pointPickerOpen = false;
            this.restoreModalFocus();
        },
        openLoginModal() {
            this.modalReturnFocus = document.activeElement;
            this.loginModalOpen = true;
            this.focusModal(".login-modal-box");
            this.startLogin = false;
            this.loginCode = "";
            this.pinError = "";
        },
        closeLoginModal() {
            this.loginModalOpen = false;
            this.restoreModalFocus();
        },
        searchPackagePoints() {
            const query = (this.mapPostCode ?? "").trim();
            if (!query) {
                return;
            }
            const isPostCode = this.countryShipping.postRegex
                ? new RegExp(this.countryShipping.postRegex).test(query)
                : false;
            if (isPostCode) {
                this.loadPackagePoints();
            } else {
                this.loadPackagePoints({city: query});
            }
        },
        useCurrentLocation() {
            if (!navigator.geolocation) {
                this.pushToast(lang?.cart?.messages?.geolocation_denied ?? "Location is not available", "info");
                return;
            }
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    this.loadPackagePoints({lat: position.coords.latitude, lon: position.coords.longitude});
                },
                () => {
                    this.pushToast(lang?.cart?.messages?.geolocation_denied ?? "We couldn't access your location", "info");
                }
            );
        },
        selectFlatMethod(method = null) {
            const target = method ?? this.shipping;
            if (!target) {
                return;
            }
            this.shipping = target;
            this.deliveryType = Number(target.type);
            this.activateSection('delivery');
        },
        selectDeliveryType(deliveryType,group){
            this.activateSection('delivery');
            this.deliveryType = deliveryType;
            if(deliveryType == 1 || deliveryType == 5) {
                this.closePointPicker();
                if (!this.deliveryAddressReady) {
                    this.shipping = null;
                    this.showMethods = false;
                    return;
                }
                const methods = group?.methods ?? [];
                const visible = methods.filter((method) =>
                    String(method.country_id) === String(this.countryShipping.id) &&
                    this.allowDeliveryMethod(method.warehouses ?? []) &&
                    this.checkPostCodeRegex(method.post_code_regex) &&
                    this.methodPricesForAddress(method).length > 0
                );
                // never a guess: the automatic-select method, or the only one available
                this.shipping = this.pickAutomaticMethod(visible);
                this.showMethods = visible.length > 1 && !visible.some((method) => method.is_automatic_select);
            }else{
                this.showMethods = false;
                this.shipping = null;
                this.shippingPrice = null;
                this.selectedPoint = undefined;
                if (!(this.mapPostCode ?? "").length) {
                    this.mapPostCode = this.savedShipping.postcode ?? "";
                }
                this.openPointPicker();
            }
        },
        enablePush() {
            AppEvents.callEvent("ALLOW_NOTIFICATIONS", {
                email: this.userData.email || this.email,
            });
        },
        updateAllowPush() {
            this.isAllowPush = window?.allowPush;
            this.isEnabledPush = window?.enabledPush;
        },
        onAddressFocusChange() {
            const active = document.activeElement;
            const ids = ["ship-postal-code", "ship-city", "bill-postal-code", "bill-city"];
            this.addressInputsFocused = Boolean(active && active.id && ids.includes(active.id));
        },
    },
    watch: {
        paymentError(message) {
            if (message && !this.checkoutSections.payment && this.step >= 2 && this.step <= 4) {
                this.showPaymentCard(false);
            }
        },
        methodListShouldStayOpen: {
            immediate: true,
            handler(stay) { if (stay && !this.showMethods) this.showMethods = true; },
        },
        showMethods(open) { if (!open && this.methodListShouldStayOpen) this.showMethods = true; },
        // the saved addresses come with the login check (after the mount): one of them can give the country
        uadressess() {
            if (!this.countryPicked) this.validateShippingCountry();
        },
        // the complete contact section of a logged in customer starts closed, once
        loggedContactComplete: {
            immediate: true,
            handler(ready) {
                if (ready && !this.contactCollapsedOnce) {
                    this.contactCollapsedOnce = true;
                    this.checkoutSections.user = false;
                }
            },
        },
        customerSyncKey() {
            this.onDraftInputChanged();
        },
        sectionsDoneKey() {
            this.advanceSections();
        },
        liveErrorKey() {
            // fixed -> the error disappears at once; new errors show up only
            // after the user stopped typing (or left the field)
            this.applyLiveErrors(false);
            clearTimeout(this.liveErrorTimer);
            this.liveErrorTimer = setTimeout(() => this.applyLiveErrors(true), 700);
        },
        deliveryAddressReady(ready) {
            if (!ready) {
                // the address is being edited: keep the chosen method (no
                // layout jump) - the delivery section is just not complete
                return;
            }
            if (this.shipping !== null && Number(this.deliveryType) !== 2 && !this.isMethodAvailableForAddress(this.shipping)) {
                this.shipping = null; // the new address rules the method out
            }
            this.autoSelectDelivery();
        },
        "countryShipping.id"() {
            this.deliveryType = null;
            this.shipping = null;
            this.selectedPoint = undefined;
            this.points = [];
            this.mapPostCode = "";
            this.savedShipping.postcode = "";
            this.savedShipping.city = "";
            this.savedShipping.street = "";
            this.savedShipping.house = "";
            this.savedShipping.state = "";
            this.savedShipping.area = "";
            this.savedShipping.package_point = "";
            // the invoice country follows the destination: a country the new destination does not allow is replaced
            if (this.invoice == 1) this.userData.countryID = this.countryShipping.id;
            this.defaultInvoiceCountry();
            this.autoSelectDelivery();
        },
        saturdayTick() {
            if (this.shipping && Number(this.shipping.type) === 6 && !this.hasSaturdayService()) {
                this.shipping = this.pickAutomaticMethod(this.selectedGroupMethods);
            }
        },
        "userData.firstName"() { this.advanceSections('user'); this.onDraftInputChanged(); },
        "userData.lastName"() { this.advanceSections('user'); this.onDraftInputChanged(); },
        "userData.phoneNumber"() { this.userDataError = false; },
        "userData.email"() {
            this.advanceSections('user');
            this.onDraftInputChanged();
            // a coupon that waited for the customer is checked again now that the e-mail is there
            if (this.couponNeedsEmail && this.validatedCoupon && /^\S+@\S+\.\S+$/.test(String(this.userData.email ?? '').trim())) {
                this.checkCoupon();
            }
        },
        "billAddress.city"() { this.advanceSections('billing'); this.onDraftInputChanged(); },
        "billAddress.street"() { this.advanceSections('billing'); this.onDraftInputChanged(); },
        "savedShipping.city"() { this.advanceSections('delivery'); this.markDeliveryChanged(); },
        "savedShipping.street"() { this.advanceSections('delivery'); this.markDeliveryChanged(); },
        "savedShipping.house"() { this.advanceSections('delivery'); this.markDeliveryChanged(); },
        "savedShipping.postcode"() { this.advanceSections('delivery'); this.markDeliveryChanged(); },
        basketTrigger(value) {
            if (value) {
                this.maybeCreateBasket();
            }
        },
        warehouses() {
            this.autoSelectDelivery();
        },
        countryDeliveryMethods(methods) {
            if (!this.cartConfig?.groupDeliveryMethods) {
                if (this.shipping !== null && !methods.some((m) => String(m.id) === String(this.shipping.id))) {
                    this.shipping = null;
                    this.deliveryType = null;
                }
                if (methods.length === 1 && this.shipping === null && this.deliveryType === null) {
                    this.autoSelectDelivery();
                }
            }
        },
        selectedGroupMethods(methods) {
            if (this.cartConfig?.groupDeliveryMethods && Number(this.deliveryType) !== 2 && this.shipping !== null) {
                if (!methods.some((m) => String(m.id) === String(this.shipping.id))) {
                    this.shipping = null;
                    this.showMethods = false;
                    this.autoSelectDelivery();
                }
            }
        },
        userSectionReady(value) {
            if (value) {
                this.advanceSections('user');
            }
        },
        paymentSectionReady(value) {
            // one-page checkout: as soon as every other section is valid
            // (incl. terms), pre-select the default payment method - the
            // payment watcher then creates the draft order + payment
            if (value && this.payment !== null) {
                // valid again (e.g. address completed): sync what changed
                this.scheduleCheckoutSync();
                return;
            }
            if (!value || this.payment !== null || this.creatingOrder) {
                return;
            }
            const choice = this.defaultPaymentChoice();
            if (choice !== null) {
                this.payment = choice;
            }
        },
        "checkoutSections.billing"(value) {
            if (value) {
                this.defaultInvoiceCountry();
            }
        },
        "checkoutSections.delivery"(value) {
            if (value) {
                this.validateShippingCountry();
                this.autoSelectDelivery();
            }
        },
        mapPostCode() {
            if(this.countryShipping.postRegex !== null && this.countryShipping.postRegex !== undefined && (this.shipping || Number(this.deliveryType) === 2)){
                let exp = new RegExp(this.countryShipping.postRegex);
                if (exp.test(this.mapPostCode)) {
                    this.loadPackagePoints();
                }
            }
        },
        pointPickerOpen(value) {
            if (value && this.points.length === 0) {
                this.loadPackagePoints();
            }
        },
        selectedPoint() {
            this.advanceSections('delivery');
            if (this.shipping !== null) {
                this.shippingPrice = this.shippingPrices(
                    this.shipping?.prices,
                    true,
                    this.selectedPoint?.type
                );
            }
            this.markDeliveryChanged();
        },
        shipping(value) {
            if (this.shipping !== null) {
                this.shippingPrice = this.shippingPrices(
                    this.shipping?.prices,
                    true
                );

                this.advanceSections('delivery');

                // default invoice choice only while the user did not choose
                if (!this.invoiceTouched || (Number(this.shipping.type) === 2 && Number(this.invoice) === 1)) {
                    if(this.shipping.type !== 2){
                        this.invoice = 1;
                    }else if (!this.expressConfirming && (this.userBill?.city?.length ??0) > 0) {
                        this.invoice = 3;
                    }else if (Number(this.invoice) === 1) {
                        this.invoice = 2; // a pickup point is not an invoice address
                    }
                }

                if(this.shipping.type == 2 && !this.expressConfirming){
                    this.openPointPicker();
                }

                if (!(Number(this.deliveryType) === 2 && this.pointPickerOpen) && !this.expressConfirming) {
                    this.loadPackagePoints();
                }
            }
            if (!this.expressConfirming) {
                this.markDeliveryChanged();
            }
        },
        walletAtOrderNow: {
            immediate: true,
            handler(at) {
                if (at) this.watchWalletSlot();
                else { clearInterval(this.walletTimer); this.walletSlotState = "off"; }
            },
        },
        payment(value, oldValue) {
            // switching methods: instantly tear down the previously loaded
            // widget, so the old price/payment never stays visible
            if (oldValue?.id > 0 && oldValue?.id !== value?.id) {
                this.blockPaymentOf(oldValue);
            }
            if (this.payment !== null && this.payment.prices !== undefined) {
                // the payment fee (e.g. COD) is charged even with free shipping
                this.paymentPrice = this.shippingPrices(
                    this.payment.prices,
                    true,
                    null,
                    false
                );
            }
            if(this.payment !== null){
                this.advanceSections('payment');
            }
            if (this.isWidgetPayment(this.payment)) {
                // background draft creation / payment init - collapses quick
                // re-selections into one request
                this.scheduleCheckoutSync(250);
            }
        },
        email() {
            if (!this.isLogged && this.userData.email !== this.email) {
                this.userData.email = this.email;
            }
            if (
                /^\w+([.\-_+]?\w+)*@\w+([.\-_+]?\w+)*(\.\w{2,20})+$/.test(this.email)
            ) {
                if (this.timeout) clearTimeout(this.timeout);
                this.canLogin = false;
                this.showLoginFields = false;
                // guests: personal data leaves the browser only after the
                // terms are accepted - the check runs then
                if (!this.termsAccepted) {
                    this.emailCheckPending = true;
                    this.isInputLoding = false;
                    return;
                }
                this.isInputLoding = true;
                this.loadingFieldName = "email";
                this.timeout = setTimeout(() => {
                    this.emailCheckPending = false;
                    this.checkEmail();
                }, 500);
            } else {
                this.isInputLoding = false;
                this.canLogin = false;
                if (this.timeout) clearTimeout(this.timeout);
            }
        },
        loginCode() {
            if (this.loginCode > 99999) {
                this.isInputLoding = true;
                this.loadingFieldName = "pin";

                this.getUserData();
            }
        },
        terms() {
            if (this.terms) {
                this.termsError = null;
            }
        },
        termsAccepted(value) {
            if (value && this.emailCheckPending) {
                this.emailCheckPending = false;
                this.checkEmail();
            }
        },

        savedShipping() {
            this.savedShippingError = false;
        },
        "billAddress.isCompany"() {
            this.billAddress.taxNumber = "";
            this.billAddress.euTaxNumber = "";
            this.billAddress.businessName = "";
            setTimeout(() => {
                forms.load();
            }, 10);
        },
        localStorageList() {
            this.items = this.localStorageList || [];
        },
        comments(){
            setTimeout(() => {
                forms.load();
            }, 10);
        },
        // an open dialog (pickup point, login) is a layer over the page: the class lets a theme lock the page behind it
        layerOpen(open) {
            document.documentElement.classList.toggle("co-layer-open", open);
        },
        // an address that is no longer complete (country or method changed) is shown for editing again
        canFoldAddress(can) {
            if (!can) this.addressFolded = false;
            else setTimeout(() => this.foldPickedAddress(), 600);
        },
        // the own invoice address becomes the choice: its section opens with the form right away
        needsInvoiceAddressForm(needed) {
            if (needed) this.checkoutSections.billing = true;
        },
        invoice(value, oldValue) {
            // the own invoice address (option 2) is kept while another option is
            // chosen - never aliased with the shipping address
            const own = this.billAddress !== this.savedShipping && this.billAddress !== this.userBill;
            if ((Number(oldValue) === 2 || oldValue === null) && own) {
                this.ownBillAddress = this.billAddress;
            }
            if (this.invoice == 1) {
                const invoiceCountries = this.invoiceCountryOptions;
                if (invoiceCountries.some((item) => String(item.id) === String(this.countryShipping.id))) {
                    this.userData.countryID = this.countryShipping.id;
                }
                this.billAddress = this.savedShipping;
                this.defaultInvoiceCountry();
            } else if (this.invoice == 3) {
                this.billAddress = this.userBill;
            } else if (!own || this.billAddress === this.savedShipping) {
                if (this.ownBillAddress) {
                    this.billAddress = this.ownBillAddress;
                } else {
                    this.clearBillingAddress();
                }
            }

            setTimeout(() => {
                forms.load();
            }, 10);
        },
    },
};

// Global cart object
const CART = {
    vue: null,
    initializePaymentButton(event) {
        return CART.vue.initializePaymentButton(event);
    },
    getDeliveryOptions() {
        return CART.vue.getDeliveryOptions();
    },
    changeCountry(code) {
        return CART.vue.changeCountry(code);
    },
    startPayment(event) {
        return CART.vue.startPayment(event);
    },
    // the country code of the invoice address (the shipping one when there is none): payment apps that hide their own country field
    billingCountryCode() {
        const v = CART.vue;
        const c = v && ((v.countryInvoice && v.countryInvoice.code) || (v.countryShipping && v.countryShipping.code));
        return c ? String(c).toUpperCase() : '';
    },
    // the theme's look options for a payment app's widget (config.json "payment_look"), {} when it gives none
    paymentLook(name) {
        return (CART.vue && CART.vue.cartConfig && CART.vue.cartConfig.paymentLook && CART.vue.cartConfig.paymentLook[name]) || {};
    },
    // the element a payment app mounts its widget into (its row, or the order button's place)
    paymentTarget(id) {
        return CART.vue.paymentTarget(id);
    },
    // a wallet button in place of the order button reported the payment: the order is finished now
    paymentDone() {
        return CART.vue.walletAtOrder(CART.vue.payment) ? CART.vue.callFinishPayment() : null;
    },
    finishPayment(event) {
        return CART.vue.finishPayment(event);
    },
    finishPaymentButton(data,event) {
        return CART.vue.finishPaymentButton(data,event);
    },
    getPrice() {
        return CART.vue.totalPrice;
    },
    get orderId() {
        return this.vue.order.id+'?token='+this.vue.order.cart_token;
    },
    load() {
        if (document.getElementById("cart") !== null && CART.vue === null) {
            if (typeof Vue === "undefined") {
                setTimeout(CART.load, 400);
                return;
            }
            CART.app = Vue.createApp(Cart);
            CART.app.component('address-fields', AddressFields);
            CART.app.component('country-field', CountryField);
            CART.app.config.errorHandler = (error, instance, info) => {
                console.error("[cart] Vue render error", {error, info, step: instance?.step});
            };
            CART.vue = CART.app.mount("#cart") ?? CART.app._instance?.proxy ?? null;
        }
    },
};
window.CART = CART;

window.addEventListener("DOMContentLoaded", () => {
    CART.load();
});

if (document.readyState !== "loading") {
    CART.load();
}

window.initMap = function () {
    window.CART.vue.$refs.map.loaded();
};

window.addEventListener('pagehide', () => {
    window.CART.vue?.abandonOnLeave();
});

window.addEventListener('beforeunload', (event) => {
    if(window.CART.vue.step > 1 && window.CART.vue.step < 4) {
        window.CART.vue.deleteBasket();
        event.preventDefault();
        event.returnValue = '';
    }
});
if ('serviceWorker' in navigator && navigator.serviceWorker.controller) {
    navigator.serviceWorker.addEventListener('message', event => {
        if (event.data.action === 'delete_basket') {
            if (window.CART.vue.basket.id === event.data.id) {
                window.CART.vue.basket.id = "";
                window.CART.vue.basket.token = "";
            }
        }
    });
}
